export default {
    "corporate": "公司计划",
    "onboarding": {
        "goal_desc": "您可以通过追踪自己的活动获取%{customPoints}，完成目标后可获得%{customPoints}奖励。现在就开始吧！您可以一次设定3个活跃个人目标。",
        "sample_task": {
            "modalActivityTitle": "3次深呼吸",
            "rewards_featured_title": "特色",
            "rewards_partners_title": "合作伙伴",
            "header_description": "您可以通过追踪活动和完成任务、目标和挑战来获取%{customPoints}。",
            "icon_text": "点击{icon} 来追踪深呼吸。",
            "activityName": "深呼吸",
            "activityUnit": "呼吸"
        },
        "lets_get_started": "让我们开始吧！",
        "start_description": "您可以通过追踪活动和完成任务、目标和挑战来获取%{customPoints}。",
        "complete_and_earn": "完成并获取",
        "did_it": "我做到了！",
        "task_complete": "任务完成了！",
        "breath_sample_task": "查看关于活动追踪的快速教程",
        "track_a_sample_activity": "追踪一个示例活动",
        "nice": "很好！",
        "nice_one": "干得漂亮！",
        "nice_subtext_1": "您已经获得了%{points}%{customPoints}。",
        "nice_subtext_2": "获取%{customPoints}将帮助您提升等级。您每提升一个等级，就会获得%{reward_currency}，可用于兑换超值产品。",
        "nice_subtext_3": "只需完成更多的任务，追踪更多的活动，达成更多的目标和挑战，您就能获取更多的积分。",
        "progress_subtitle": "每%{frequency}会重置您的%{customPoints}和进度。",
        "skip_for_now": "暂时跳过",
        "loadingText": "我们正在计算您的健康分数，请稍等片刻。",
        "goal_title": "设定个性化目标",
        "swipe_for_more": "滑动查看更多内容",
        "skip_goals": "我现在已经完成了目标设定。",
        "complete_profile": "",
        "level": "等级",
        "finish_onboarding_action": "请先完成新手培训",
        "vital_stats": {
            "height_ft": "身高（英尺）",
            "height_in": "身高（英寸）"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "您的隐私很重要"
        },
        "levels": {
            "title": "成就和奖励",
            "tableTitle": "成就"
        },
        "initialScreen": {
            "title": "%{username}，欢迎加入%{programName}！",
            "getRewarded": "获得%{rewardName}奖励",
            "completeAgainst": "与您的同事竞争",
            "earnPoints": "通过健康活动获取积分",
            "levelUp": "提升等级并解锁徽章"
        },
        "starterGoals": {
            "title": "选择目标",
            "subtitle": "培养新的健康习惯，开启您的健康之旅。"
        }
    },
    "healthkit_not_available": "无法连接Apple Health。在Health应用程序中的“Sources”下，确保您至少启用了读取步数的权限，并且至少有追踪到1步。",
    "changeCover": "更改照片",
    "joiningCommunityToast": {
        "success": {
            "message": "您已成功加入%{name}",
            "title": "加入社区"
        }
    },
    "achievement_starts_date": "开始日期：%{date}",
    "editChallenge": "编辑%{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "最多选择5项活动",
            "title": "您想要做什么？",
            "noActivityTitle": "添加活动",
            "noActivityMessage": "选择至少一项活动或类别。",
            "categoryItemDescription": "%{category}类别中的所有活动",
            "addActivityTitle": "您每%{period}希望完成多少%{unit}的%{activity}？",
            "addCategoryQuantityTitle": "您想在%{category}类别中获取多少%{customPoints}？",
            "subtitleCategories": "选择一个类别。该类别的所有活动都有助于实现目标。",
            "subtitleWithActivities": "最多%{max}个活动，已选择%{num}个",
            "selectCategoryMessage": "选择该类别中的所有活动，之前选中的活动将会放弃。",
            "addActivityTitleTotal": "您想在%{period}内完成多少进度的%{activity}？"
        },
        "inviteDepartments": {
            "title": "邀请部门"
        },
        "inviteRegions": {
            "title": "邀请地区"
        },
        "createInvitation": {
            "selectMore": "请至少选择2个%{entity}！"
        },
        "visibility": {
            "title": "可见性",
            "description": "所有%{programName}用户都可以找到并加入团队挑战。"
        },
        "highest": {
            "name": "最多%{customPoints}者获胜",
            "description": "没有限制，%{customPoints}最高的获得第一名"
        },
        "compete": {
            "individual": "以个人形式参加",
            "team": "以团队形式参加"
        },
        "unitType": {
            "title": "选择您的目标完成方式",
            "subtitle": "从活动或某个类别中选择"
        },
        "category": {
            "name": "一个类别中的所有活动",
            "description": "例如，追踪“运动”中的任何活动",
            "title": "选择类别",
            "subtitle": "您将在哪个类别中追踪活动？"
        },
        "activities": {
            "name": "已选择的活动",
            "description": "例如，追踪特定的活动，如骑自行车",
            "title": "选择活动",
            "subtitle": "我们建议专注于一项活动，但您最多可以添加5项活动",
            "maxModalTitle": "已选择最多活动",
            "maxModalDescription": "您最多可以添加5项活动。点击“接受”，继续进行您所选择的5项活动，或点击“编辑”进行更改。",
            "warningModalTitle": "高难度",
            "warningModalDescription": "您在这个目标中指定了很多需要在一个周期内完成的活动。您是否确定要设定这样一个具有挑战性的目标？",
            "requiredPoints": "要求达到%{period}%{challengeType}",
            "noActivitiesModalTitle": "添加活动",
            "noActivitiesModalDescription": "至少选择一项活动。"
        },
        "categoryQuantity": {
            "title": "设定您的%{customPoints}目标",
            "subtitle": "您希望每%{period}从%{category}中获得多少%{customPoints}？",
            "subtitleTotal": "您希望在%{period}从%{category}中获得多少%{customPoints}？",
            "text": "作为指导原则，30分钟的中等强度活动相当于约105%{customPoints}",
            "noQuantityModalTitle": "数量",
            "noQuantityModalDescription": "输入一个数值",
            "defaultCategoryTitle": "当前类别"
        },
        "cancel": {
            "title": "取消创建挑战",
            "message": "您是否确定取消创建挑战？"
        },
        "createNew": "创建新挑战",
        "chooseChallengeTitle": "选择一个挑战或创建您自己的挑战",
        "createOwn": {
            "title": "创建自己的"
        },
        "frequency": {
            "title": "您达成目标的频率为多少？",
            "subtitle": "每日目标能帮助您养成习惯"
        },
        "startAndDuration": {
            "title": "选择一个开始日期和持续时间",
            "subtitle": "",
            "noFieldsTitle": "开始日期和持续时间",
            "noFieldsMessage": "请填写开始日期和持续时间"
        },
        "finalize": {
            "title": "查看您的新目标",
            "subtitle": "",
            "noFieldsTitle": "名称和说明",
            "noFieldsMessage": "请填写名称和说明",
            "name": "我的%{frequency} %{names}目标",
            "instructionCategory": "从所有%{category}活动中%{frequency}%获取{points} %{customPoints}",
            "instructionActivities": "%{frequency}追踪%{items}，并%{pointsFrequency}获取%{points} %{customPoints}",
            "instructionCompetitionCategory": "从所有%{category}活动中获得最多的%{customPoints}，以赢得本次比赛",
            "instructionCompetitionActivities": "从%{items}中获得最多的%{customPoints}，以赢得本次比赛",
            "namePlaceholder": "给您的比赛命名",
            "titleChallenge": "最终完成您的挑战"
        },
        "dailyDescription": "例如：每天喝8杯水",
        "weeklyDescription": "例如：每周步行150分钟",
        "monthlyDescription": "例如：每个月跑150公里",
        "totalDescription": "例如：骑自行车共计10,000公里",
        "title": "挑战自己还是他人？",
        "navigatorTitle": "创建挑战",
        "me": {
            "name": "只挑战自己",
            "description": "以个人目标的形式挑战自己"
        },
        "others": {
            "name": "与他人竞争",
            "description": "个人或团队竞争"
        },
        "one": {
            "name": "个人",
            "description": "与其他用户进行个人竞争"
        },
        "team": {
            "name": "作为团队",
            "description": "作为团队与其他团队竞争"
        },
        "company": {
            "name": "公司挑战",
            "description": "创建特殊比赛"
        },
        "adminItemTitle": "作为管理员，您可以创建",
        "userOrTeamTitle": "个人还是团队竞争？",
        "target": {
            "name": "设定要达到的目标",
            "description": "有上限的挑战"
        },
        "typeTitle": "选择一个%{challengeType}类型",
        "teamSizeTitle": "为每个团队选择规模",
        "teamSizeSubtitle": "一个团队的最小人数是%{min}，最大人数是%{max}。您团队的%{customPoints}是团队中所有成员的平均数，只有当您的团队达到最小成员数后，您才能获得%{customPoints}。",
        "teamSize": {
            "noFieldsTitle": "最小和最大",
            "noFieldsMessage": "选择一个团队的最小和最大成员数"
        },
        "companyChallengeTitle": "公司挑战",
        "companyChallengeSubtitle": "您是管理员。您可以设置部门和其他类型的挑战",
        "chooseDepartmentTitle": "选择部门进行竞争",
        "chooseRegionTitle": "选择地区进行竞争",
        "goToChallenge": "前往我的挑战",
        "additional": {
            "title": "挑战已创建",
            "subtitle": "让我们开始吧！ 邀请其他人加入。",
            "makePublicName": "选择公开",
            "makePublicDescription": "任何人都可以加入",
            "toDirectoryName": "提交到挑战目录",
            "toDirectoryDescription": "人们可以像这样创建一个",
            "inviteTitle": "邀请参加挑战",
            "titleGoal": "目标已创建！"
        },
        "quantityMinimum": {
            "message": "最低要求数量为%{quantity}",
            "title": "数量不足"
        },
        "toast": {
            "success": "您的%{challengeType}已创建。"
        },
        "goToGoal": "前往我的目标",
        "navigatorTitleGoal": "创建目标",
        "quantityError": {
            "wholeNumber": "必须是整数",
            "greaterThanZero": "必须大于0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "通过比较您与其他数百万同年龄且同性别人群的健康问卷调查回复，计算得出您的健康分数。您的分数显示了您在其中的排名。根据应用程序所输入的运动、饮食和感觉行为的变化，每月自动更新您的分数。通过设定连续的目标和采取积极行动来改善您的健康状况，这有助于提高您的健康分数。",
            "excellent": "您的健康分数高于85%的同年龄且同性别人群。",
            "very_good": "您的健康分数高于70-84%的同年龄且同性别人群。",
            "good": "您的健康分数高于51-69%的同年龄且同性别人群。",
            "fair": "您的健康分数高于31-50%的同年龄且同性别人群。",
            "poor": "您的健康分数低于70%的同年龄且同性别人群。健康是一辈子的课题。让我们的平台成为您健康之路上的好帮手！",
            "overall_result": "总体而言，您的健康分数为%{status}。",
            "category_result": "总体而言，您的{category}分数为{string}。",
            "goals": "没有目标，就没有胜利的喜悦。设定最多3个目标，并紧密追踪。随着时间的推移，在您逐渐改变生活方式后，就会看到分数的不断提高。"
        },
        "reminder": {
            "title": "快来更新您的健康问卷调查！",
            "updateAnswers": "更新我的回复"
        },
        "lastUpdated": "最后更新时间为%{date}",
        "scoreDescription": {
            "part1": "您的分数是",
            "part2": "分数为",
            "belowAverage": "低于平均分",
            "aboveAverage": "高于平均分",
            "part3": "针对其他同年龄且同性别的人。"
        },
        "improveScore": {
            "description": "根据您的健康问卷调查回复和已追踪的活动来计算您的分数。您可以通过更新调查回复或设定新目标来提高分数。",
            "desc1": "您的分数已经登峰造极！要让日常活动保持有趣，您就需要用稍微超出您的正常能力的目标挑战自己，并邀请他人与您竞争，让您时刻动力满满。",
            "desc2": "如果您已经做好升级准备，现在正是增加挑战的时候。用稍微超出您的正常能力的目标挑战自己，并邀请他人与您竞争，让您时刻动力满满。",
            "desc3": "设定个人目标，并创建公开挑战，让自己坚持下去并保持动力。记得要选择能够完成的目标并且设定较小的时间框架——我们推荐您选择1周。",
            "desc4": "保持每天运动是很重要的。如果您在日常生活中没有太多运动，您可以先从与您的能力和兴趣相匹配的小目标入手。记得要选择能够完成的目标并且设定较小的时间框架——我们推荐您选择1周。"
        },
        "recommendedGoals": "推荐的目标",
        "recommendedDescription": {
            "desc1": "您最多可以设定",
            "desc2": "3个专注目标",
            "desc3": "来改善您的健康状况。您目前有"
        },
        "categoryScore": "您的%{category}分数为",
        "learnMore": "了解更多",
        "youAreSet": "设定好了！",
        "goalSetting": "目标设定",
        "attention": "无法提供%{category}分数。",
        "move": {
            "error": "根据您的回复，无法得出您的运动分数。"
        },
        "eat": {
            "error": "您表示有医疗保健专业人士告知您患有2型糖尿病，而且没有得到控制。"
        },
        "feel": {
            "error": "根据您的回复，无法提供您的感觉分数。"
        },
        "survey": {
            "requiredField": "*此栏为必填项"
        },
        "score_info_title": "我的分数意味着什么",
        "company_average_info": "我公司的平均分",
        "demographic_average_info": "同类人群的平均分",
        "score": "健康分数",
        "table": {
            "what_it_means": "这意味着什么",
            "score": "分数"
        },
        "updated": "已更新",
        "label": {
            "excellent": "优秀",
            "very_good": "很好",
            "good": "不错",
            "fair": "一般",
            "poor": "不佳"
        },
        "activity": {
            "eat": "饮食活动1，饮食活动2，饮食活动3",
            "move": "运动活动1, 运动活动2, 运动活动3",
            "feel": "感觉活动1，感觉活动2，感觉活动3"
        },
        "score_info_screen": "我的分数是如何计算得出的？",
        "details": "详细信息",
        "activities": "活动",
        "improveCategoryScore": "提高我的%{category}分数",
        "meaning": {
            "heading": "分数计算"
        },
        "score_button": {
            "meaning": "这个分数意味着什么？"
        },
        "improve": "查看推荐的目标",
        "score_text": {
            "demographic": "您同年龄和同性别人群的平均分是",
            "company": "而您所在公司的平均分是"
        },
        "scoreHigher": "高于平均",
        "scoreLower": "低于平均",
        "settedGoals": {
            "noGoals": "没有设定目标",
            "one": "已设定1个目标",
            "n": "已设定%{count}个目标"
        },
        "yourScoreIsPoor": "您的%{category}分数表现不佳",
        "unlock": {
            "title": "解锁您的健康分数",
            "description": "填写完成简短的调查问卷，以了解您的整体健康相较同类人群是怎样的水平。"
        },
        "browseAndSet": "在完成当前的目标后，您可以浏览和设定新的目标。",
        "excellent": {
            "desc1": "极为健康的生活方式",
            "desc2": "健康风险很低"
        },
        "veryGood": {
            "desc1": "很健康的生活方式",
            "desc2": "健康风险低"
        },
        "good": {
            "desc1": "健康的生活方式",
            "desc2": "健康风险一般"
        },
        "fair": {
            "desc1": "较为健康的生活方式",
            "desc2": "健康风险高于平均水平"
        },
        "poor": {
            "desc1": "健康风险高",
            "desc2": "建议加强日常运动",
            "desc3": "需要加强日常运动"
        },
        "calculateScore": {
            "description": "在您填写完成健康调查以后，我们将使用来自您的年龄和性别群体的数十亿数据变量来分析您的回答。计算还将纳入您在%{programName}追踪的活动。\n\n您的健康分数将定期更新，以便您看到随时间而发生的变化。"
        },
        "improveYourScore": "提高您的分数"
    },
    "challengerCount": "%{num}名挑战者",
    "team_name": "团队名称",
    "syncingDeviceToast": {
        "danger": {
            "message": "糟糕……我们在同步%{name}时遇到了问题。请再试一次。",
            "title": "同步"
        },
        "success": {
            "title": "同步",
            "message": "成功同步%{name}。您的活动现在为最新数据。"
        }
    },
    "allCompanyMembers": "所有公司成员",
    "allCompanyMembersTeam": "所有公司成员（团队）",
    "successfullyRedeemedItemForConfirmation": "您已经成功兑换了该物品，确认邮件已发送至%{email}。",
    "no_all_events_placeholder": "目前似乎没有可加入的活动。何不自己创建一个？",
    "confirmDeleteAccount": "通过输入您账户关联的电子邮箱来确认删除",
    "deleteAccount": "删除账户",
    "linkAccounts": "管理关联账户",
    "titleSlug": {
        "icon_reward_text": "符合条件的会员可以通过在我们的合作伙伴处购物，或在Members’ Choice Advantage牙医诊所使用其附加保险进行检查，从而轻松获得更多积分。",
        "icon_move_text": "追踪日常的健康选择，如改善睡眠或多吃蔬菜，可以为您赢得Live Better积分。",
        "icon_redeem_text": "对于拥有医疗保险或附加保险的Medibank会员，Live Better会为他们保持健康的行为提供奖励。",
        "icon_phone_text": "注册后即可获得奖励，例如健康和福利礼品卡或节省健康保险费用。",
        "wellness": "欢迎来到追求健康的乐土",
        "goals": "实现您的目标",
        "devices": "保持进度",
        "challenges": "创建挑战",
        "celebrate": "社交健康",
        "habits": "培养健康的习惯",
        "joinChallenge": "加入挑战",
        "getSocial": "进行社交",
        "reward": "因健康生活而获得奖励。",
        "move": "改善运动、饮食和感觉。",
        "phone": "生活更美好，身心更健康。"
    },
    "viewProgress": {
        "goal": "查看目标进度",
        "challenge": "查看挑战进度",
        "progress": "查看进度"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "输入该信息为可选项，是为了您自身利益和隐私。"
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "本次活动可获得%{potentialBonusPoints}奖励%{customPoints}积分！"
        },
        "modal": {
            "paragraph1": "参加该活动，您将获得奖励%{pointsName}。",
            "paragraph2": "所有的奖励%{pointsName}都将在活动结束后发放。对于您未参加的活动，您将不会获得相应的奖励积分。"
        }
    },
    "EAP": {
        "contactInfo": "联系信息",
        "doLater": "我稍后进行",
        "tellMore": "我想了解更多",
        "contactMe": "联系我",
        "title": "员工和家庭援助计划",
        "reachGoal": {
            "title": "可提供帮助",
            "description": "%{providerName}提供的员工和家庭援助计划（EFAP）带来各种健康辅导服务，帮助您实现健康目标。\n\n您是否希望%{providerName}与您联系，提供更多信息？"
        },
        "privacyPolicy": "%{provider}隐私政策"
    },
    "HRIS": {
        "disclaimer": "有些字段会自动更新且无法更改。"
    },
    "settingGoals": {
        "description": "一次专注3个推荐目标将提高您成功的几率。",
        "title": {
            "one": "您已设定1个目标"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "账户已经链接至另一名用户",
            "lastAccountMessage": "您是否确定要删除最后一个链接账户？一旦删除，您必须用电子邮箱%{email}和新密码登录。",
            "unlinkCorpAccountMessage": "您是否确定要删除您的公司链接账户？一旦删除，您必须再次使用电子邮箱%{email}登录。",
            "alreadyLinked": "已链接账户",
            "unlinkMessage": "您是否确定要删除已链接的账户？"
        },
        "sso": {
            "emailNotVerified": "您还未验证电子邮箱。"
        },
        "signIn": {
            "dontHaveAccount": "没有账户怎么办？",
            "enterPIN": "输入您公司的计划识别码",
            "dontKnowPIN": "不知道您的PIN码怎么办？",
            "pin": "PIN码",
            "register": "注册",
            "pinDescription": "如果您不确定组织的独有计划识别码（PIN），请联系您的计划管理员。如果您有了PIN码，但在下一步遇到困难，请联系support@sproutatwork.com。",
            "keepMeTooltip": "为了您的便利，当勾选此框时，您的会话将在30天内保持有效。在共享设备上，我们建议您取消勾选此框，并在结束后注销。"
        },
        "signUp": {
            "backToLogin": "返回到登录",
            "termsOfService": "服务条款",
            "privacyPolicy": "隐私政策"
        },
        "createYourAccount": "创建您的账户",
        "setYourDetails": "设置您的详细信息",
        "ModaHybridLogin": {
            "noAccessDashboard": "无权访问会员仪表板吗？",
            "signUpSSOButton": "通过 Moda 会员控制面板注册",
            "noAccessDashboardWeb": "如果您无权访问会员仪表板，请使用下面的电子邮件和密码登录。",
            "loginSSOButton": "通过 Moda 会员仪表板登录"
        }
    },
    "entityHasBeenDeleted": "%{name}已删除",
    "track_challenge": {
        "message": {
            "manually": "手动追踪",
            "automatically": "通过%{appOrDeviceName}自动追踪",
            "manuallyOrConnect": "手动追踪或连接应用程序或设备",
            "manuallyAndBy": "使用%{appOrDeviceName}手动和自动追踪",
            "reconnectDevice": "需要设备。请重新连接您的设备",
            "manualAndAuto": "手动和自动追踪",
            "trackedAutomatically": "自动追踪"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "无法注册",
            "message": "无法从合作伙伴处检索到用户的详细信息。请稍后再试"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "该%{goalName}目标需要应用程序或设备。",
            "subTitle": "请连接应用程序或设备"
        }
    },
    "descriptionSlug": {
        "wellness": "加入健康社区，帮助您设定目标、建立连接并保持追踪。",
        "goals": "和我们分享您正在努力的方向。我们会通过推荐的目标来帮助您实现最终目的。",
        "devices": "同步您的健身设备或记录您的活动，保持您的健康目标进度。",
        "challenges": "激发一些友好竞争。创建挑战，并邀请其他人加入，获得更多乐趣。",
        "celebrate": "与同事保持联系，共同庆祝取得的成功。",
        "habits": "追踪健康活动，获取更多积分。链接至您的手机或可穿戴设备，更快地获取积分。",
        "joinChallenge": "在友好比赛中，看看您和同事的比拼。",
        "getSocial": "与同事保持联系，共同庆祝取得的成功。",
        "reward_text": "通过完成每日活动和个人挑战来获取积分。",
        "move_text": "无论是在街区散步、五分钟冥想还是连续的健康饮食，它们都能让您获得奖励。",
        "phone_text": "您可自由选择用积分兑换保费折扣或优惠产品。",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "未启用功能",
        "checkAppVersion": {
            "message": "您的应用程序似乎版本过旧。请安装最新的更新。",
            "button": "更新%{appName}"
        },
        "noConnection": {
            "title": "没有网络连接",
            "description": "您似乎没有连接到互联网。除非您连接成功，否则您将无法使用应用程序的全部功能。",
            "button": "重试"
        },
        "uploadPhotoText": "为您的%{entityType}添加照片",
        "entities": {
            "community": "社区",
            "event": "活动",
            "team": "团队",
            "goal": "目标",
            "challenge": "挑战",
            "competition": "比赛"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "无法登录",
            "resetPasswordHeading": "需要重置密码"
        },
        "signup": {
            "corporateOrOther": "不是Medibank会员？或者是企业计划的一部分？",
            "sign_up_here": "在此注册",
            "errorHeading": "无法注册",
            "areYouMedibankMember": "您是Medibank会员吗？",
            "isMedibankMember": "我是会员",
            "isNotMedibankMember": "我不是会员"
        },
        "bpidExists": "所提供的电子邮箱已绑定其他Live Better用户，电子邮箱不能重复。",
        "generalError": "服务目前不可用"
    },
    "rewardsNoAvailableProducts": "目前没有可用的产品。",
    "endedGoal": {
        "timeToTrack": {
            "yes": "您仍有时间追踪！",
            "no": "您的%{type}已结束"
        },
        "grace": "您的%{type}可能已结束，但您还有%{n} %{text}来追踪任何忘记的活动",
        "notGrace": {
            "goal": "恭喜您完成了目标！ 继续努力，设定新目标，保持健康的状态。",
            "competition": "恭喜您完成了挑战！ 参加其他挑战，保持势头，或创建自己的挑战。"
        }
    },
    "appDeviceModal": {
        "defaultMessage": "连接您的设备或应用程序，进行无缝追踪。您授权我们的技术合作伙伴“Sprout”从您的%{appDeviceTitle}账户安全传输您的数据。"
    },
    "noTransactionsMessage": "您似乎还没有进行任何交易。",
    "noRedemptionsMessage": "您似乎还没有进行任何兑换。",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "您能够以个人或团队的形式参加挑战",
            "prompt": "现在没有挑战可以加入。何不创建一个？"
        },
        "createChallengeButton": "创建挑战"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "活动可以是邀请制，也可以向任何人开放。",
            "button": "创建一个活动"
        },
        "emptyEventsMessage": "现在没有活动可以加入。何不创建一个？"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "健康",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "您没有设定任何目标！",
            "descriptionNoSet": "通过设定目标来提高您的健康分数。采用推荐的目标快速开始，从目录中选择，或创建您自己的目标。",
            "descriptionSet": "您可以从我们为您准备的推荐目标中选择一个，浏览完整的目录，或者创建您自己的目标。",
            "action_text": "设定新目标",
            "heading_singular": "您可以再设置1个目标",
            "heading_plural": "您可以再设置%{number}个目标"
        },
        "heading": "个人目标",
        "single": "个人目标"
    },
    "settingGoal": {
        "yourGoal": "您的%{units}",
        "yourGoalDescription": "开始健康之旅！ 设定以下%{units}，并立即开始。",
        "selectedGoals": "选定的目标",
        "recommendedDescription": {
            "maximumSet": "您已经设定了最大数量的目标。您可以在完成当前目标后，浏览并设置新目标。",
            "maximumSetTitle": "您已经设定了%{count}个目标"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "活动已删除",
            "info": "出错了。请再试一次。",
            "danger": "出错了。请再试一次。"
        },
        "plural": {
            "success": "活动已删除",
            "info": "出错了。请再试一次。",
            "danger": "出错了。请再试一次。"
        },
        "success": "活动已删除",
        "info": "活动未删除。请再试一次。",
        "danger": "活动未删除。请再试一次。"
    },
    "participants": "参与者",
    "members": "成员",
    "timeSittingInformationOld": "指导建议： \n- 尽量减少久坐时间。\n - 尽可能频繁地中断久坐时长。",
    "timeSittingInformation": {
        "title": "指导建议：",
        "list": "- 尽量减少久坐时间。\n- 尽可能频繁地中断久坐时长。"
    },
    "activityLevelInformationOld": "指导建议：- \n每周大部分时间，最好是每天都有活动。\n- 每周积累150分钟以上的中等强度体育活动。\n- 每周至少进行2天的肌肉强化活动。",
    "activityLevelInformation": {
        "title": "指导建议：",
        "list": "- 每周大部分时间，最好是每天都有活动。\n- 每周积累150分钟以上的中等强度体育活动。\n- 每周至少进行2天的肌肉强化活动。"
    },
    "viewGuidelines": "查看指导",
    "corporateAccountLink": {
        "verification": {
            "title": "验证您的工作电子邮箱",
            "description": "您需要验证自己的工作电子邮箱，以成功完成链接流程。请按照发送至以下邮箱的说明进行："
        }
    },
    "invitation": {
        "findFriendsAndFamily": "查找朋友和家人",
        "findFriends&Family": "查找朋友和家人",
        "tapToAddFriendsAndFamily": "点击添加至朋友和家人",
        "addedFriendsAndFamily": "已添加至朋友和家人",
        "whoYouAreLookingFor": "没有看到想找的人？",
        "inviteWithEmail": "通过电子邮件邀请",
        "sentInvitations": "发送邀请",
        "foundPerson": "我们发现该人的电子邮件相匹配",
        "youAreBoth": "你们都在%{entityName}",
        "youAreBothMore": "你们都在 %{entityName}, +%{n}以上",
        "noFriendsAndFamilyAdded": "您似乎还没有添加任何朋友或家人。",
        "sendInvitation": "发送邀请",
        "youHaveNoSentInvitations": "您还没有发送任何邀请",
        "toast": {
            "success_title": "已发送邀请",
            "success_description": "%{invite_email}将在其收件箱中看到邀请",
            "danger_title": "邀请失败",
            "danger_description": "请稍后再试"
        },
        "email": {
            "invalid_email": "请输入一个有效的电子邮箱"
        },
        "inviteOthers": "邀请其他人",
        "searchForSomeone": "搜索用户",
        "searchForOthersToInvite": "搜索邀请其他人",
        "programNameOnly": {
            "title": "仅限%{programName}",
            "description": "该%{entityType}仅适用于加入%{programName}的人"
        },
        "domainCannotBeUsed": "该领域不能与%{programName}一起使用",
        "actionSearchByEmail": "如果您无法找到要邀请的人，请通过电子邮件邀请",
        "send": "发送",
        "addEmailToList": "添加电子邮件至列表",
        "toBeSent": "将要发送的邀请",
        "noInvitationsToBeSent": "没有邀请",
        "removeEmailConfirmation": "您是否确定要从列表中删除该电子邮箱？",
        "yes": "是",
        "no": "否",
        "foundByEmail": "我们发现该人的电子邮件相匹配",
        "addToFriendsAndFamily": "添加到朋友和家人",
        "alreadyAddedEmail": "您已经将此电子邮箱添加到列表中"
    },
    "pointsCurrencyAdditionalInfo": "您的%{points_name}和等级每%{period}就会重新开始。您的所有已追踪活动都会对您在当期的总体等级有所影响。",
    "rankLabel": "排名",
    "leaderboards": {
        "loadingLabel": "正在加载排行榜……这可能需要几分钟 - 大家似乎都在外面活动！"
    },
    "feeds": {
        "emptyListHomePage": "目前还没有帖子显示。请尝试调整推荐来显示更多的帖子。",
        "viewingPostsFrom": "查看帖子，来自",
        "postActivity": "添加活动的评论或照片！",
        "indicatorLoader": {
            "defaultTitle": "刷新……",
            "successfulLoadedTitle": "已同步并刷新……"
        },
        "inapropriateTextError": {
            "message": "您信息中可能有不良内容。请尽量使用更友好的语言。"
        },
        "postImageError": {
            "title": "对不起，我们不能发布该帖子",
            "message": "您添加的图片可能含有不良内容。请尝试其他的图片。"
        }
    },
    "syncModal": {
        "connect": {
            "title": "连接%{name}",
            "description": "如需将您的%{name}数据与您的账户连接，请完成以下步骤：",
            "firstStep": "从%{storeName}下载并安装%{appName}移动应用程序",
            "fourthStep": "选择与%{name}连接",
            "fifthStep": "当出现提示时，选择要与%{appName}同步的健康指标，并点击“完成”",
            "additionalInfo": "请注意，如需从健康应用程序触发同步，必须打开%{appName}。虽然您无需一直打开应用程序，但可能需要一个小时才能完成同步，并出现在您的活动日志中。"
        },
        "title": "同步%{name}",
        "description": "如需将您的%{name}数据同步到账户，请完成以下步骤：",
        "steps": {
            "one": "登录您手机上的%{appName}",
            "two": "打开您个人资料中的“应用程序和设备”",
            "three": "按下%{name}旁边的同步按钮",
            "iPhone": "登录您iPhone上的%{appName}应用程序"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "工作账户",
            "message": "账户成功连接"
        },
        "danger": {
            "message": "连接账户出错"
        },
        "conflict": {
            "message": "账户已链接至其他用户"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "工作账户",
            "message": "账户成功断开连接"
        },
        "danger": {
            "title": "链接账户",
            "message": "账户断开连接出错"
        }
    },
    "earnMoreWithPartners": "通过合作伙伴获取更多",
    "connectPartnersToEarnByShopping": "连接您的账户，通过在合作伙伴%{program_name}处购物来获取更多%{unit_type}。",
    "viewAllPartners": "查看所有合作伙伴",
    "myPartnerMemberships": "我的合作伙伴会员",
    "linkAccount": "链接会员",
    "linkToPartner": "链接至合作伙伴",
    "linkingError": "链接您的账户时出现了问题。请再试一次。",
    "linkPending": "待链接",
    "unlinkAccount": "解除链接账户",
    "linkedToPartnerName": "已链接至%{partner_name}",
    "linked": "已链接",
    "permission": {
        "facebookTitle": "使用Facebook注册",
        "googleTitle": "使用Google注册",
        "facebookDescription": "在使用Facebook注册时，您需要授权我们的技术合作伙伴“Sprout”访问您的身份信息并创建您的%{programName}账户。",
        "googleDescription": "在使用Facebook注册时，您需要授权我们的技术合作伙伴“Sprout”访问您的身份信息并创建您的%{programName}账户。",
        "camera": {
            "title": "相机访问",
            "description": "拍摄照片需要授权相机访问。在iPhone设置中，点击%{appName}并启用相机。\n\n请注意，您可能会丢失任何未保存的更改。"
        },
        "notNow": "现在不行",
        "openSettings": "打开设置",
        "photos": {
            "title": "请授权照片访问",
            "description": "这能让您分享图库中的照片，并将照片保存到您的相册中。在iPhone设置中，点击%{appName}并将照片切换为读和写。\n\n请注意，您可能会丢失未保存的更改。"
        }
    },
    "firstNameContainsSpecialChar": "您的名只能包含英文字母、连字符-和撇号'",
    "lastNameContainsSpecialChar": "您的姓只能包含英文字母、连字符-和撇号'",
    "goToPartnerSite": "转到合作伙伴网站",
    "noPartnersFound": "没有找到合作伙伴",
    "noLinkedPartners": "没有已链接的合作伙伴",
    "noPartnersInCategory": "类别中没有合作伙伴",
    "partnerAccountPendingVerification": "账户待验证",
    "shopWithPartner": "在合作伙伴处购物",
    "shopWithPartnerName": "在%{partner_name}购物",
    "linkToPartnerName": "链接至%{partner_name}",
    "earnPartnerMembershipIdentifier": "会员识别码",
    "earnPartnerAccountPendingAddLink": "正在链接您的会员，可能需要几天时间才能完成。",
    "earnPartnerAccountPendingRemoveLink": "正在取消您的会员链接，可能需要几天时间才能完成。",
    "linkStatusUpdating": "链接状态更新",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "恭喜您添加了第一批活动！ \n\n如果您愿意，您可以为今天和其他日期添加更多活动。完成今天的活动后，",
            "description2": "当您没有更多要追踪的活动时，点击下一个屏幕"
        },
        "listTitle": "追踪的活动",
        "dots": {
            "tracked": "本日追踪的活动",
            "added": "活动已添加并等待提交"
        },
        "trackedActivitiesFor": "在%{date}追踪的活动",
        "activityTracking": "活动追踪",
        "addedPending": "已添加（待提交）",
        "search": {
            "description1": "点击",
            "description2": "查看可参加的活动或搜索特定的活动"
        },
        "addActivity": "添加活动",
        "addAnotherActivity": "添加另一项活动"
    },
    "rewardsBalance": "%{currencyName}余额：%{points}",
    "membershipIdentifierRequiredError": "您的会员识别码是进行链接的必要条件",
    "incorrectValueInRange": "请输入一个介于%{min}和%{max}之间的数值",
    "joinTeam": {
        "title": "加入团队",
        "createInsteadText": "加入或创建团队来参与该挑战"
    },
    "teamRank": "团队排名",
    "teamScore": "团队分数",
    "appsDevices": {
        "infoText": "在添加应用程序或设备时，您需要授权我们的技术合作伙伴Sprout Wellness Solutions, Inc.访问您的健康数据。",
        "connectModal": {
            "title": "授权",
            "paragraph1Part1": "您需要授权我们的技术伙伴",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "访问您的健康数据。",
            "paragraph2Desc1": "您的授权让",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "能够安全地同步您的",
            "paragraph2Desc4": "数据",
            "paragraph2Desc5": "，并帮助您获取更多%{pointsName}！"
        },
        "statusAlert": {
            "connectMessage": "连接应用程序或活动追踪设备，轻松同步和追踪活动",
            "connectAction": "连接应用程序或设备",
            "errorMessage": "部分已连接的应用程序或设备无法同步",
            "warningMessage": "部分已连接的应用程序或设备可能有连接问题",
            "errorAction": "修复该错误",
            "warningAction": "修复该警告",
            "syncingError": "同步错误",
            "syncingIssue": "同步问题"
        },
        "deviceDetails": {
            "warningMessage": "该应用程序或设备在同步时出现问题",
            "errorMessage": "该应用程序或设备无法同步",
            "warningAction": "解除警告",
            "noActivities": "在过去7天，没有将%{deviceName}活动同步到%{programName}。\n\n使用%{deviceName}追踪活动后，可能需要一个小时才能在此显示活动。\n\n如果您连接了其他应用程序或设备，并且其他应用程序或设备追踪了更多的步数，您将看到那里的活动。否则，请尝试断开连接并重新连接%{deviceName}。如果您需要进行认证或授予权限，请确保您启用了活动数据，并使用与追踪活动相同的账户进行认证。请查看故障排除步骤以了解更多信息。"
        },
        "troubleshooting": "故障排除",
        "deviceItem": {
            "error": "连接错误",
            "warning": "连接警告",
            "unableToSync": "无法同步"
        },
        "platformDevice": {
            "defaultApp": "您设备的默认健康应用程序是",
            "continueMore": "继续更多的应用程序和设备"
        }
    },
    "friendsAndFamily": {
        "learnMore": "了解更多关于朋友和家人的信息",
        "learnModal": {
            "title": "朋友和家人简介",
            "description": "当您将人添加到您的朋友和家人中后，您可以选择只与他们分享您在%{programName}上的帖子。\n\n如果他们向所有人或您发了帖子，您还可以在%{programName}上过滤为只看您朋友和家人列表上的人发送的帖子。",
            "description_line1": "当您将人添加到您的朋友和家人中后，您可以选择只与他们分享您在%{programName}上的帖子。",
            "description_line2": "如果他们向所有人或您发了帖子，您还可以在%{programName}上过滤为只看您朋友和家人列表上的人发送的帖子。",
            "whatIconsMean": "图标的含义",
            "canAdd": "添加",
            "added": "已添加"
        },
        "searchDescription1": "搜索要添加到朋友和家人列表上的人。",
        "searchDescription2": "没有看到想找的人？通过电子邮件邀请他们加入。",
        "friends&Family": "朋友和家人",
        "managingTour": {
            "title": "管理朋友和家人",
            "body": "如果您想把某人移除朋友和家人列表，请点击图标"
        },
        "removeOption": "从朋友和家人列表移除",
        "inviteDescription1": "搜索您的朋友和家人。",
        "inviteDescription2": "没有看到您要找的人？"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "您只与朋友和家人分享的帖子将不再对%{userFirstName}显示。"
        }
    },
    "skipAll": "全部跳过",
    "smallMin": "最小",
    "eap": {
        "skipModal": {
            "title": "您是否确定？",
            "description": "如有需要，欢迎您随时从个人资料中联系员工及家庭援助计划。"
        },
        "contact": {
            "whatIsBestNumber": "最方便与您联系的号码是多少？",
            "whatIsBestTime": "最方便与您联系的时间是什么时候？",
            "morning": "上午",
            "afternoon": "下午",
            "evening": "晚上",
            "additionalDetails": "您希望进行联系的时间\/日期的更多详细信息",
            "message": "请在%{weekDay}通过%{phoneNumber}联系我。其他信息：%{additional}",
            "description": "注意事项：我们强烈建议您选择工作时间之外的时间，并选择能够进行私人对话的地点。请写明您的时区。"
        },
        "phoneNumber": {
            "empty": "此栏不能为空",
            "missingDigits": "电话号码必须至少包含4位数字"
        },
        "myEAP": "我的员工和家庭援助计划"
    },
    "healthSurveySkipAllTitle": "跳过健康问卷调查",
    "healthSurveySkipAllAlert": "您是否确定要跳过健康问卷调查的所有剩余问题？",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "员工和家庭援助计划",
            "message": "请提供您最方便的电话号码和联络时间"
        }
    },
    "allMyChallenges": "我的挑战",
    "invitedChallenges": "邀请",
    "companyChallenges": "公司的挑战",
    "completedChallengesEmpty": "您似乎还没有完成任何挑战。",
    "myChallengesEmpty": "您似乎还没有加入任何挑战。",
    "allChallengesEmpty": "没有挑战。",
    "startsToday": "今天开始",
    "startedDaysAgo": "开始于%{dayCount}天前",
    "startsInDays": "开始于%{dayCount}天后",
    "privacyOn": "关闭",
    "privacyOff": "于",
    "dashboard": {
        "viewLeaderboard": "查看排行榜",
        "timePeriodProgress": "该%{period}的进度",
        "howToEarn": "如何获取积分"
    },
    "privacyChangeConfirmationMessage": "改变隐私？",
    "privacySettingsTitle": "隐私",
    "privacySettingsDescription": "您可以控制照片、名字和个人资料对其他用户的可见性。",
    "mainLeaderBoardSettingsTitle": "？总排行榜",
    "challengeLeaderBoardSettingsTitle": "？挑战排行榜",
    "managePrivacySettingUrlTitle": "管理隐私设置",
    "onboardingFamilyPrivacySettingsMessageOn": "您在朋友和家人的搜索结果中可见。您可以选择让自己在搜索结果中不可见。",
    "onboardingFamilyPrivacySettingsMessageOff": "您的隐私设置目前让自己在朋友和家人的搜索结果中不可见。",
    "challengeInvitationPrivacySettingsMessageOn": "您在挑战邀请搜索结果中可见。您可以选择让自己在搜索结果中不可见。",
    "challengeInvitationPrivacySettingsMessageOff": "您的隐私设置目前让自己在挑战邀请搜索结果中不可见。",
    "challengeParticipationPrivacySettingsMessageOn": "您被列为该挑战的参与者。您可以选择隐藏自己挑战参与者的身份。",
    "challengeParticipationPrivacySettingsMessageOff": "您的隐私设置目前让自己在参与者列表中不可见。",
    "communityInvitationPrivacySettingsMessageOn": "您在社区邀请搜索结果中可见。您可以选择让自己在搜索结果中不可见。",
    "communityInvitationPrivacySettingsMessageOff": "您的隐私设置目前让自己在社区邀请搜索结果中不可见。",
    "communityParticipationPrivacySettingsMessageOn": "您被列为该社区的成员。您可以选择隐藏自己社区成员的身份。",
    "communityParticipationPrivacySettingsMessageOff": "您的隐私设置目前让自己在会员列表中不可见。",
    "eventInvitationPrivacySettingsMessageOn": "您在活动邀请搜索结果中可见。您可以选择让自己在搜索结果中不可见。",
    "eventInvitationPrivacySettingsMessageOff": "您的隐私设置目前让自己在活动邀请搜索结果中不可见。",
    "eventParticipationPrivacySettingsMessageOn": "您被列为该活动的参与者。您可以选择隐藏自己活动参与者的身份。",
    "eventParticipationPrivacySettingsMessageOff": "您的隐私设置目前让自己在参与者列表中不可见。",
    "mainLeaderboardPrivacySettingsMessageOn": "您会显示在总排行榜上。您可以选择隐藏自己，这将在其他人查看总排行榜时移除您的排名、图片和名字。",
    "mainLeaderboardPrivacySettingsMessageOff": "您的隐私设置目前让自己在别人查看总排行榜时不可见。",
    "challengeLeaderboardPrivacySettingsMessageOn": "您会显示在挑战排行榜上。您可以选择隐藏自己，这将在其他人查看挑战排行榜时移除您的排名、图片和名字。",
    "challengeLeaderboardPrivacySettingsMessageOff": "您的隐私设置目前让自己在别人查看挑战排行榜时不可见。",
    "thumbsUpConfirmationTitle": "点赞",
    "thumbsUpConfirmationDescriptionline1": "恭喜，您将首次点赞并鼓励他人！",
    "thumbsUpConfirmationDescriptionline2": "您将被列入该帖子的点赞名单中，其他人可以看到您的照片和名字，并可以查看您的个人资料。",
    "thumbsUpConfirmationButtonOk": "点赞",
    "commentToActionInfoTitle": "别人会看到什么？",
    "commentToActionMessage": "当您评论时，其他人可以看到您的照片和名字，并可以查看您的个人资料。",
    "postToActionTitle": "谁会看到这个帖子？",
    "postToActionMessageLine1": "当您发布一个帖子时，您可以控制哪些人可以看到它，甚至能够只自己可见。",
    "postToActionMessageLine2": "您与他人分享的帖子将显示您的照片和名字，他人可以查看您的个人资料",
    "privateUsersDescriptionChallenge": "这些参与者已在列表中不可见",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n}私密",
    "privateUsersLastNamePlaceHolderChallenge": "参与者",
    "privateUsersDescriptionEvent": "这些参与者已在列表中不可见",
    "privateUsersFirstNamePlaceHolderEvent": "%{n}私密",
    "privateUsersLastNamePlaceHolderEvent": "参与者",
    "privateUsersDescriptionCommunity": "这些成员已在列表中不可见",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n}私密",
    "privateUsersLastNamePlaceHolderCommunity": "成员",
    "noPrivacySettings": "没有隐私设置",
    "linkToPartnerNameWebsite": "通过%{partner_name}网站链接",
    "linkToPartnerWebsiteUrl": "合作伙伴网站的URL",
    "start_end_time": "开始和结束时间：",
    "joinCreateTeamPrivacyDisclaimer": "在挑战中查看您的团队时，您的照片、名字和个人资料将始终保持对任何人可见，即使您将隐私设置改为私密。",
    "carouselInstructions": {
        "swipe": "滑动卡片可以查看您所有的目标和挑战。",
        "click": "点击卡片可以查看您所有的目标和挑战。"
    },
    "achieved": "已达成",
    "hours": "小时",
    "createCommunityFlow": {
        "navigatorTitle": "创建社区",
        "stepType": {
            "title": "社区可见性",
            "subTitle": "谁能看到并加入社区？",
            "privateName": "私密",
            "publicName": "公开",
            "privateDescription": "只有您邀请的人才能看到或加入这个社区",
            "publicDescription": "任何人都可以看到和加入这个社区"
        },
        "stepName": {
            "title": "为您的社区命名",
            "subTitle": "为您的社区命名，让人们知道它的性质。",
            "namePlaceholder": "社区名称",
            "noFieldsTitle": "名称",
            "noFieldsMessage": "未提供名称"
        },
        "stepDescription": {
            "title": "您的社区简介",
            "subTitle": "向别人介绍您的社区。",
            "descriptionPlaceholder": "描述（可选）",
            "noFieldsTitle": "描述",
            "noFieldsMessage": "未提供描述"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "添加照片"
        },
        "stepJoin": {
            "title": "我们找到了类似的社区",
            "subTitle": "您想加入这些社区吗？"
        },
        "createNew": "创建新社区"
    },
    "challengeCard": {
        "allActivities": "类别中的",
        "category": "所有活动"
    },
    "myLinkedPartners": "我的已链接合作伙伴",
    "leaderboardPosition": "总排行榜排名",
    "remainingInChallenge": "仍在挑战中",
    "todays_progress": "今日进度",
    "this_weeks_progress": "本周进度",
    "this_months_progress": "本月进度",
    "achievement": "成就",
    "challengeCardHeader": {
        "challenge": "挑战",
        "recommended_personal_goals": "推荐的个人目标",
        "personal_goal": "个人目标",
        "competition": "比赛",
        "recommended_goals": "推荐的目标",
        "team_competition": "团队比赛",
        "team": "团队"
    },
    "MyMedibank": "我的Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "结束时间不能早于开始时间",
    "company": "公司",
    "lessThan1DayRemain": "少于1天",
    "lessThan1HourRemain": "少于1小时",
    "remainingToday": "今日剩余时间",
    "periodEndsDateAndTime": "周期结束时间为%{date}，%{time}",
    "moreToGo": "还有%{n}的%{unit}，从",
    "reachedYourGoal": "您%{period}达到了目标！",
    "reachedYourGoalToday": "您今天达到了目标！",
    "editProfileItemCorrectRange": "请提供一个介于最小值%{min}和最大值%{max}之间的有效%{itemName}值",
    "invalidUrl": "无效的URL",
    "activityLogChanged": {
        "success": "已保存所作的活动更改",
        "info": "出错了……请再试一次。",
        "danger": "出错了……请再试一次。"
    },
    "discardAlert": {
        "createChallenge": "您是否确定要放弃该%{challengeType}？",
        "inviteByEmail": "您是否确定您要放弃这些更改？",
        "createTeam": "您是否确定要取消创建团队？",
        "cancel": "取消",
        "confirm": "是，放弃"
    },
    "entityInvalidNameError": "%{entity}的名称应只包含数字或字符串值，不能为空",
    "accept": "接受",
    "sync_now": "开始同步",
    "reconnect_device": "重新连接",
    "supported_activities": "支持的活动",
    "recentlySynced_activity": "最近同步的活动",
    "noSyncedActivity_sevenDays": "在过去7天，没有活动进行同步",
    "recentActivityLog": {
        "convertingActivityPoints": "同步活动……",
        "activityMinuteOrTwo": "这可能需要一或两分钟……",
        "noNewActivities": "没有添加新的活动……新的活动可能需要一个小时才能完成同步。"
    },
    "deleteCommunityCheckbox": "我知道这一步不能撤销",
    "createEvent": {
        "type": {
            "company": "公司活动",
            "user": "用户活动",
            "title": "活动类型"
        },
        "privacy": "隐私（是否显示参与者）",
        "cost": "费用",
        "associated": {
            "location": "相关地点",
            "department": "相关部门"
        },
        "maxParticipants": "最多参与人数（可选）",
        "errorMessage": {
            "limit": "不能超过%{maxValue}",
            "negative": "不能为负值",
            "selectedLocations": "请选择一个或多个地点"
        },
        "selectLocations": "已选择的地点",
        "createNew": "创建新活动"
    },
    "selected": "已选择",
    "deleteEventButton": "删除该活动",
    "notification": {
        "priorityNotification": {
            "title": "您有未读的重要更新",
            "subtitle": "点击并立即阅读",
            "subtitleWeb": "点击并立即阅读"
        },
        "sectionTitle": {
            "priorityUnread": "未读的重要更新",
            "all": "所有通知"
        },
        "modalTitle": "您有%{count}条重要更新",
        "priorityModalTitle": {
            "defaultTitle": "查看所有更新"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "取消%{entity}%{actionType}",
            "message": "您是否确定要取消%{entity}%{actionType}？"
        },
        "action": {
            "creating": "创建",
            "editing": "编辑"
        },
        "type": {
            "team": "团队",
            "community": "社区",
            "event": "活动",
            "challenge": "挑战",
            "goal": "目标"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "选择公开？",
            "private": "选择私密？"
        },
        "modalSubtitle": {
            "public": "公开该%{entityType}，它将向所有人开放查找和加入。您是否确定要公开该%{entityType}？",
            "private": "私密该%{entityType}，它将禁止任何人查找和加入。您是否确定要私密该%{entityType}？"
        },
        "footerButton": {
            "makePublic": "是，公开",
            "makePrivate": "是，私密",
            "keepPrivate": "保持私密",
            "keepPublic": "保持公开"
        },
        "label": {
            "title": "使其成为公开的%{entityType}",
            "subtitle": "每个人都可以看到并加入"
        }
    },
    "imageUploader": {
        "changeImageButton": "更改图片"
    },
    "copyright": "© Sprout 2019，版权所有",
    "samsunghealth_not_available": "无法与Samsung Health连接。在Health应用程序中的“数据授权”下，确保您至少启用了读取步数的权限，并且至少有追踪到1步。",
    "rewardsHowDoIEarn": "我该如何获取%{currencyName}？",
    "unlockAchievements": "解锁成就",
    "unlockAchievementsDescription": "追踪活动，获取%{pointsName}，解锁等级，获取更多%{currencyName}。点击每个成就，查看您需要做什么。",
    "myDay": "我的一天",
    "myGoalsChallengesTasks": "我的目标、挑战和任务",
    "yourGoalsChallenges": "您的目标和挑战",
    "mySocialStream": "社区帖子",
    "viewAllAchievements": "查看所有成就",
    "viewAllBonusChallenges": "查看所有奖励挑战",
    "newVersionOfAppAvailable": "新版本上市！ 请重新加载此页面",
    "noBonusChallengesToDisplay": "目前没有可参加的奖励挑战。",
    "bonusChallenges": "奖励挑战",
    "reloadAppVersion": "重新加载",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "您是否确定要删除追踪%{activity_name}？",
    "activity_tracker_instruction_header": "点击日期来追踪该天的活动，或者查看已经追踪的活动。",
    "alertDashboardFunctionalityToBeAdded": "这里将添加文字来解释追踪周期是什么，类似于航空公司忠诚计划的做法，用户需要在一个日历年内不断积累“里程”，以获得下一年的等级。",
    "noNumberEntered": "输入活动量",
    "feed": "推荐",
    "home": "首页",
    "challenges": "挑战",
    "explore": "探索",
    "rewards": "奖励",
    "reward": "奖励",
    "balance": "我的%{programName}奖励余额",
    "profile": "个人资料",
    "loading": "正在加载……",
    "me": "我的信息",
    "back": "上一步",
    "next": "下一步",
    "skip": "跳过",
    "signup": "注册",
    "signin": "登录",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "登录Live Better",
    "signup_with_medibank": "注册成为Medibank会员",
    "signup_with_facebook": "使用Facebook注册",
    "signup_with_google": "使用Google注册",
    "signup_with_email": "使用电子邮箱注册",
    "signin_with_medibank": "使用我的Medibank登录",
    "signin_with_facebook": "使用Facebook登录",
    "signin_with_google": "使用Google登录",
    "signin_with_email": "使用电子邮箱登录",
    "signup_heading": "创建账户",
    "not_a_medibank_member": "不是Medibank会员？",
    "keep_me_signed_in": "保持登录状态",
    "forgotpassword": "忘记密码？",
    "emailaddress": "电子邮箱",
    "password": "密码",
    "enterEmailAddress": "输入您的电子邮箱",
    "enterYourPassword": "输入您的密码",
    "password_for_error": "密码",
    "reset_password": "重置密码",
    "passwordResetSuccess": "重置密码",
    "passwordResetEmailSent": "如果我们的系统中有匹配的电子邮箱，那么重置密码说明已经通过电子邮件发送给您。",
    "loginerror": "登录时发生了错误：",
    "logincancelled": "登录已取消",
    "part_of_corporate_program": "您打算注册加入企业计划吗？",
    "continue_here": "在此继续",
    "program_name": "计划名称",
    "error_provide_program_name": "请提供计划名称。",
    "program_not_found": "未找到计划",
    "registration_field_email": "电子邮箱",
    "employeeId": "雇员ID",
    "registration_field_firstName": "名",
    "registration_field_lastName": "姓",
    "no_first_name": "没有名",
    "no_last_name": "没有姓",
    "registration_field_password": "新密码",
    "no_disclaimer_available": "糟糕，出现了问题……我们无法检索到您所在组织的条款和条件。请稍后再注册。",
    "registration_account_not_registered": "您似乎还没有验证自己的电子邮箱。您是否希望我们重新发送邮件？",
    "resend_verification_email": "电子邮箱验证",
    "resend_verification_email_successful": "我们已经重新发送了验证邮件。",
    "resend_verification_email_unsuccessful": "糟糕，出现了问题……我们无法重新发送验证邮件。请再试一次。",
    "not_supported": "该帖子现在无法显示。请稍后再试。",
    "policyAgreeError": "如需继续，请同意服务条款和隐私政策。",
    "challenge_completion_bonus": "完成奖励",
    "me_tabs": {
        "activity": "活动",
        "bookmarks": "书签"
    },
    "health_tab": {
        "my_health_score": "您的健康分数",
        "overall_health_score_description": "您的健康分数为",
        "health_score_explanation": "您的健康分数是根据您对自己健康状况的回答和您的活动程度计算得出的。\n\n您的分数每个月都会根据活动等级而进行更新。您可以设定并完成个人目标，从而提高自己的健康分数。",
        "health_score_calculation_failed_onboarding": "出现了问题，我们未能检索到您的健康分数。您现在可以继续，一旦问题得到解决，我们将更新您的分数。"
    },
    "track_activity": "追踪活动",
    "track_an_activity": "追踪一项活动",
    "track": "追踪",
    "unable_to_track": "无法追踪",
    "enter_before_track": "输入要追踪的活动量",
    "what_to_share": "您想分享什么类型的更新？",
    "remove": "删除",
    "activity_tracking_description": "您想追踪多少%{units}？",
    "excessive_submission": "太棒了！ 您即将为%{activity_name}追踪超过2000%{customPoints}。在提交之前，您应确保该信息准确无误。",
    "on": "于",
    "in": "于",
    "from": "于",
    "at": "于",
    "no_activities": "没有搜索到任何匹配活动。",
    "activity_tracking_desc": "您需要添加一个数字才能继续。点击左角的“X”来取消。",
    "activity_tracking_desc2": "点击活动上的任何位置进行编辑，点击“+”来快速追踪目标",
    "vital_stats_title": "您的资料",
    "invalid_numeric_response": "无效",
    "invalid_numeric_response_range": "该数字必须介于%{minimum}和%{maximum}之间",
    "search_placeholder": "搜索资料库……",
    "search_activities": "搜索活动",
    "searching": "正在搜索……",
    "searchEmpty": "没有找到匹配的内容",
    "vital_stats_description": "向我们介绍一下自己",
    "health_survey_questions": "健康问卷调查问题",
    "health_survey_title": "完成健康问卷调查",
    "health_survey_results": "健康问卷调查结果",
    "health_survey_card_desc": "参加调查，了解您的健康状况并制定个性化目标。",
    "apps_devices_title": "链接应用程序和设备",
    "apps_devices_card_desc": "同步您的应用程序和设备，轻松获取%{customPoints}。",
    "interests_title": "兴趣爱好",
    "interests_card_desc": "告诉我们您的兴趣爱好。这将帮助我们推荐您可能感兴趣的目标和社区。",
    "interests_screen_desc": "您对什么感兴趣？",
    "health_obj_title": "健康目标",
    "health_obj_card_desc": "我们认为可以开始设定一些目标了。我们知道您的目标后，就能为您提供更好的建议。不要担心，如果改变主意，您之后可以在个人资料中轻松修改目标。",
    "health_obj_screen_desc": "您想在哪些方面努力？",
    "my_heatlh_obj": "我的健康目标",
    "health_topic_title": "健康主题",
    "health_topic_card_desc": "通过指定健康主题，个性化您的体验。",
    "health_topic_screen_desc": "您希望学习什么？",
    "multi_select_check_error": "请至少选择1项继续",
    "my_health_topics": "我的健康主题",
    "build_your_profile": "建立您的个人资料",
    "personalize_title": "个性化",
    "personalize_desc": "通过回答几个简单问题，个性化您的体验。",
    "set_goals_title": "查看推荐的目标",
    "set_goals_desc": "设定个性化目标，开始您的健康之路。",
    "set_this_goal": "设定该目标",
    "goal_set": "设定目标",
    "required": "需要",
    "apps_devices_description": "连接到健身平台，从而自动获得更多%{customPoints}。",
    "connected": "已连接",
    "num_connected": "(已连接%{numDevices}台)",
    "available": "已准备好",
    "inProgress": "正在进行中……",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "最近一次同步",
    "last_synced_lc": "最近一次同步",
    "no_connected_devices": "没有已连接的设备",
    "apps_devices_confirm_disconnect": "您是否确定断开连接",
    "button_delete": "删除",
    "button_disconnect": "断开连接",
    "button_cancel": "取消",
    "button_dismiss": "解除",
    "ok": "是",
    "waist_helper_text": "您的腰围应在肋骨下方测量，通常是在肚脐的位置，而且是在站立的情况下测量。如果不确定，请使用您的牛仔裤尺寸。",
    "apps_devices_manage": "管理我的应用程序和设备",
    "my_apps_devices": "我的应用程序和设备",
    "completeRegistration": "完成注册",
    "havingTrouble": "遇到问题怎么办？",
    "contactUs": "请联系support@sproutatwork.com寻求帮助",
    "done": "完成",
    "brand": "Sprout",
    "cannotTrackTitle": "无法追踪活动",
    "cannotTrackPrior": "停一停。只有在开始日期之后才能追踪活动。",
    "cannotTrackFuture": "没那么快。活动只能追踪到当前日期。",
    "cannotTrack": "活动追踪的有效时间为开始日期至当前日期。",
    "disclaimer": "免责声明",
    "acceptTerms": "我接受这些条款和条件",
    "verificationEmailTitle": "验证您的电子邮箱",
    "email_not_yet_verified": "您似乎还没有验证自己的电子邮箱。",
    "email_successfully_verified_title": "欢迎",
    "email_successfully_verified": "您已经成功验证电子邮箱",
    "pleaseVerifyEmailMessage1": "您需要验证电子邮箱后才能继续。",
    "pleaseVerifyEmailMessage2": "请按照发送至以下邮箱的说明进行：",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "重新发送电子邮件",
    "restart": "返回到登录",
    "firstName": "名",
    "firstNamePlaceholder": "您的名",
    "lastName": "姓",
    "lastNamePlaceholder": "您的姓",
    "email": "电子邮箱",
    "emailPlaceholder": "您的电子邮箱",
    "employeId": "雇员ID",
    "employeIdPlaceholder": "公司员工ID",
    "passwordPlaceholder": "新密码",
    "datePickerTitle": "选择您的出生日期",
    "datePickerConfirm": "确认",
    "datePickerCancel": "取消",
    "termsOfUsePrivacyPreLinks": "我同意",
    "sendMePromoCommunications": "向我发送促销邮件",
    "sendMePromoCommunicationsFromPartners": "向我发送合作伙伴的促销邮件",
    "termsOfService": "服务条款",
    "legal": "法律",
    "privacyPolicy": "隐私政策",
    "and": "和",
    "programDomainLabel": "计划名称",
    "programDomainPlaceholder": "计划名称",
    "findProgramName": "查找我的计划名称",
    "findProgramNameButton": "查找计划名称",
    "findProgramNameTitle": "查找我的计划名称",
    "findProgramNameDescription": "公司电子邮箱",
    "findProgramNamePlaceholder": "电子邮箱",
    "findProgramSuccessMessage": "计划名称的搜索结果已通过电子邮件发送给您。",
    "findProgramSuccessTitle": "计划名称",
    "findProgramErrorTitle": "计划名称",
    "findProgramErrorMessage": "糟糕，出现了问题……我们在检索您的计划名称时遇到了错误。请再试一次。",
    "countryLabel": "选择国家\/地区",
    "countryName": "国家\/地区",
    "regionLabel": "选择地区",
    "regionName": "地区",
    "cityLabel": "选择城市",
    "cityName": "城市",
    "locationWorkLabel": "选择地点",
    "locationWorkName": "地点",
    "locationLabel": "选择地点",
    "locationName": "地点",
    "departmentLabel": "选择部门",
    "departmentName": "部门",
    "no_department": "没有部门",
    "enterPIN": "请输入您的公司PIN码",
    "verifyEmailTitle": "电子邮箱验证",
    "verifyEmailMsg": "您似乎还没有验证自己的电子邮箱",
    "resendEmailTitle": "电子邮箱验证",
    "resendEmailMsg": "重新发送至%{userEmail}",
    "select_date": "选择日期",
    "changePasswordTitle": "更改密码",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "passwordChangeError": {
        "currentPasswordMissing": "输入您的当前密码",
        "newPasswordMissing": "输入您的新密码",
        "confirmPasswordMissing": "确认您的新密码",
        "passwordsMatch": "密码不匹配",
        "passwordIncorrect": "密码不正确。请再试一次。"
    },
    "settings": "设置",
    "signOut": "退出登录",
    "updateApp": "更新应用程序",
    "updateAppRight": "当前版本：%{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "获得帮助",
    "feedback": "反馈意见",
    "feedback_success_title": "提交的反馈意见",
    "feedback_success_msg": "非常感谢您提交反馈意见！",
    "feedback_failure_title": "错误",
    "feedback_failure_msg": "很遗憾……提交您的反馈时出现了错误，请再试一次。",
    "submit": "提交",
    "feedback_char_limit": "您超过了最大字符数。",
    "feedback_char_limit_toast_title": "信息太长",
    "feedback_char_limit_toast_msg": "您的信息超过了2000个字符的最大限制。",
    "feedback_char_length_msg_1": "您已经输入了",
    "feedback_char_length_msg_2": "\/2000个字符。",
    "feedback_empty_toast_title": "信息为空",
    "feedback_empty_toast_msg": "您似乎还没有输入任何内容。请在提交前输入信息。",
    "feedback_email_message": "信息：",
    "feedback_email_user_id": ", 用户ID：",
    "feedback_email_device": ", 设备：",
    "feedback_email_os_version": ", 操作系统版本：",
    "feedback_email_app_version": ", 应用程序版本：",
    "savingUserToast": {
        "success": {
            "title": "保存更改",
            "message": "保存配置文件的更改"
        },
        "danger": {
            "title": "遇到错误",
            "message": "糟糕……我们在保存您的更改时遇到了错误，请再试一次。"
        }
    },
    "edit_profile_user_error_msg": "在保存您的更改前，请查看错误说明",
    "edit_profile_location_error": "您需要写明所在位置",
    "edit_profile_department_error": "您需要写明所在部门",
    "edit_profile_unspecified_value": "您需要确定一个数值",
    "edit_profile_value_too_low": "该值必须大于",
    "edit_profile_value_too_high": "该值必须小于",
    "choose_gender": "选择性别",
    "activity_tracked_successfuly": "正在追踪您的活动",
    "multi_activity_tracked_successfully": "正在追踪您的活动",
    "no_activities_tracked": "没有追踪的活动",
    "track_activity_to_submit": "在日历上选择日期来追踪活动",
    "last_day": "最近一次",
    "days_remaining": "剩余天数",
    "day_remaining": "剩余天数",
    "days_remaining_this_week": "本周剩余天数",
    "day_remaining_this_week": "本周剩余天数",
    "days_remaining_this_month": "本月剩余天数",
    "day_remaining_this_month": "本月剩余天数",
    "earned_today": "今日获取",
    "earned_this_week": "本周获取",
    "earned_this_month": "本月获取",
    "earned_in_total": "总计获取",
    "goal_completed": "目标完成，",
    "see_results": "查看结果",
    "pts": "%{customPoints}",
    "of": "的",
    "daily_goal": "每日目标",
    "weekly_goal": "每周目标",
    "monthly_goal": "每月目标",
    "total_goal": "总目标",
    "weeks": "周",
    "today": "今日",
    "this_week": "本周",
    "this_month": "本月",
    "overall": "总体",
    "level": "等级",
    "days_remaining_in_period": "%{remainingDays}天的剩余天数",
    "days_left_in_period": "%{remainingDays}天的剩余追踪天数",
    "pointsToLevel": "%{levelName}的达成进度",
    "levelCompleted": "已完成%{levelName}",
    "keepTrackingUntil": "继续追踪，直到",
    "activityLevelTitle": "我的活动等级",
    "activityLevelDescription": "在一个星期里，您通常会花多少时间进行至少中等强度的活动，即活动强度足以提高您的心率并出汗？",
    "activityLevelUnder60": "60分钟以下",
    "activityLevelUnder150": "60至150分钟",
    "activityLevelOver150": "150分钟以上",
    "gender_male": "男性",
    "gender_female": "女性",
    "gender_rather_not_say": "不愿透露",
    "date_of_birth": "出生日期",
    "height": "身高",
    "Height": "身高",
    "weight": "体重",
    "waistCircumference": "腰围",
    "bloodPressureHg": "收缩压",
    "bloodPressureMm": "舒张压",
    "bloodCholesterol": "血液总胆固醇",
    "ldl": "低密度脂蛋白(LDL)",
    "hdl": "高密度脂蛋白(HDL)",
    "restingHeartRate": "静态心率",
    "percentageBodyFat": "体脂肪百分比",
    "hipCircumference": "臀围",
    "bloodGlucose": "血糖",
    "triglycerides": "甘油三酯",
    "error_401_signed_out_message": "您的会话已过期。请重新登录。",
    "first_name": "名",
    "last_name": "姓",
    "preferred_name": "首选名称",
    "notifications": "通知",
    "notificationsMarkAllReadButton": "将所有通知标记为已读",
    "notificationsSettingsButton": "设置",
    "notificationsSettingsTitle": "通知和电子邮件",
    "notificationEmptyMessage": "您已查看最新通知",
    "priorityModalTitle": "我的优先通知",
    "remindMeLater": "稍后提醒我",
    "priorityAdminTitle": "管理员发出的通知",
    "markAsRead": "标记为已读",
    "expand": "点击展开",
    "collapse": "点击折叠",
    "takePhoto": "拍摄新照片",
    "choosePhoto": "选择照片",
    "deletePhoto": "删除照片",
    "profileImageChangeErrorTitle": "遇到错误",
    "profileImageChangeErrorMessage": "糟糕……编辑您的照片时出现了问题。请再试一次。",
    "editProfile": "编辑个人资料",
    "postButton": "发布",
    "shareYourDayName": "您最近在忙什么?",
    "greeting": "%{firstNameDisplay}，你好！",
    "shareAnUpdate": "您最近在忙什么?",
    "shareYourDaySubtitle": "您最近在忙什么?",
    "shareAPost": "分享帖子",
    "postVisibleTo": "可见性为",
    "link": "链接",
    "photo": "照片",
    "insertLink": "在您的帖子中添加链接",
    "save": "保存",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "在提交之前，您需要在帖子中添加内容。",
    "generalErrorTitle": "帖子为空",
    "generalSuccessTitle": "成功",
    "simplePlaceholder": "您最近在忙什么?",
    "likesCountLabel": "点赞",
    "likesReceivedLabel": "收到点赞",
    "commentsCountLabel": "评论",
    "commentsCountLabelSingular": "评论",
    "likeButton": "点赞",
    "commentButton": "评论",
    "seePreviousComments": "查看以前的评论",
    "addCommentPlaceholder": "发布评论",
    "postCommentButton": "发布",
    "seeMoreLongComment": "查看更多",
    "activityPoints": "%{customPoints}",
    "activityLog": "活动日志",
    "discardPost": "放弃",
    "discardPostMessage": "您是否确定要放弃您的帖子？",
    "stream_filter_title": "推荐",
    "stream_filter_screen_desc": "选择您想在推荐中看到的帖子",
    "stream_filter_selection": "显示：",
    "moderate": "标记为不良",
    "moderateDescription": "把该项目标记为不良后将从推荐中删除，并通知管理员。",
    "editPost": "编辑帖子",
    "deletePost": "删除帖子",
    "deleteComment": "删除评论",
    "editComment": "编辑评论",
    "visibleOnlyToMe": "只对自己可见",
    "joinEvent": "活动的RSVP",
    "joinEventDetail": "加入活动",
    "joinedEvent": "我会参加",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "您已参加该活动",
            "message": "您已成功参加该活动"
        }
    },
    "joinChallenge": "参加挑战",
    "viewChallenge": "查看挑战",
    "joinedChallenge": "已参加挑战",
    "joinCommunity": "加入社区",
    "joinedCommunity": "已加入社区",
    "joinProgress": "加入",
    "joinSuccess": "已加入",
    "invitePeopleToCommunity": "邀请他人加入社区",
    "numberOfMembers": "%{num}名成员",
    "joinToView": "加入该社区，查看帖子并向其他成员发帖",
    "numberOfAttendees": "%{num}名参与者",
    "numberOfParticipants": "%{num}名参与者",
    "numberOfMembersWithUser": "您和%{num}名其他成员",
    "numberOfAttendeesWithUser": "您和%{num}名其他参与者",
    "numberOfParticipantsWithUser": "您和%{num}名其他参与者",
    "communityMembers": "%{numberOfMembers}名成员",
    "communityEvents": "%{numberOfEvents}个即将举行的活动",
    "myEvents": "我的活动",
    "seeAll": "查看所有",
    "noUpcomingEvents": "没有即将举行的活动。快加入一个活动！",
    "myCommunities": "我的社区",
    "invitedCommunities": "已被邀请",
    "invitationSendingMessage": "正在发送邀请……",
    "invitationReceivedMessage": "邀请您加入",
    "invitationMessage": "我们很希望您能加入我们的社区！",
    "recommendedCommunities": "为您推荐",
    "leaveCommunity": "离开该社区",
    "leaveTeam": "您是否确定离开该",
    "leaveTeamLastMember": "挑战团队？作为该团队的最后一名成员，离开挑战将删除团队。",
    "leaveTeamChallenge": "挑战团队？",
    "Oops": "糟糕，出错了",
    "editCommunity": "编辑社区",
    "deleteCommunity": "删除该社区",
    "leaveCommunityDescription": "您是否确定离开该社区？",
    "inviteToCommunity": "邀请加入社区",
    "inviteByMembers": "通过名字邀请",
    "inviteByEmail": "通过电子邮件邀请",
    "select_person": "请至少选择一个人进行邀请",
    "no_users_found": "嗯……我们似乎找不到这个名字的人。",
    "promptJoinCommunities": "您似乎还没有加入任何社区。加入社区，与他人互动并分享您的旅程。",
    "exploreCommunities": "探索社区",
    "sendInviteByMembers": "邀请%{num}人",
    "sendInviteByEmail": "发送电子邮件邀请",
    "createNewCommunity": "创建一个新社区",
    "createCommunity": "创建社区",
    "uploadCover": "添加照片",
    "cover": "简介",
    "nameOfCommunity": "社区名称",
    "whatCommunityAbout": "这是个关于什么的社区？",
    "companyMembersOnly": "仅限公司成员",
    "viewAllButton": "查看所有",
    "communities": "社区",
    "contentLibrary": "资料库",
    "events": "活动",
    "past_events": "过去的活动",
    "invitationCommunity": "社区",
    "searchPeople": "搜索人员",
    "enterEmail": "输入电子邮箱",
    "personalMessageToNewInvitees": "给受邀者的个人消息",
    "dangerToastTitle": "错误",
    "dangerToastMessage": "嗯……出错了。请再试一次。",
    "successToastTitle": "成功",
    "successToastMessage": "操作完成",
    "joiningToast": {
        "success": {
            "message": "您已加入"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "评论已删除"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "评论已标记为不良"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "评论已更新"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "评论已更新"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "个人照片已更新"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "照片 照片已删除"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "发布到推荐",
            "message": "您的帖子已创建"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "编辑帖子",
            "message": "您的帖子已编辑"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "删除帖子",
            "message": "您的帖子已删除"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "标记为不良",
            "message": "帖子已标记为不良"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "标记为已读",
            "message": "所有通知已标记为已读"
        },
        "info": {
            "title": "标记为已读",
            "message": "所有通知都已标记为已读。"
        },
        "danger": {
            "title": "标记为已读"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "无法将该通知标记为已读"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "密码已更新",
            "message": "请使用新密码登录"
        },
        "danger": {
            "title": "更新密码",
            "message": "糟糕……我们更新您的密码时出现了问题。请再试一次。"
        }
    },
    "joining": {
        "success": {
            "message": "您加入了%{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "邀请",
            "message": "已发送邀请"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "创建社区",
            "message": "您的新社区已创建"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "您的目标已重新启动"
        },
        "danger": {
            "message": "无法重新启动目标"
        }
    },
    "quit": "退出",
    "wellbeing_survey_completed": "健康问卷调查已完成",
    "wellbeing_survey_completed_message": "感谢您完成调查。我们希望这能帮助您更多地了解自己的健康状况。",
    "update_wellbeing_score": "更新我的调查回复",
    "get_wellbeing_score": "获得您的健康分数",
    "stats": "统计数据",
    "my_wellbeing_score": "我的健康分数",
    "see_details": "查看详情",
    "how_score_calculated": "我的分数是如何计算得出的？",
    "contentTitle": "资料库",
    "promoted": "特色",
    "recommended": "已推荐",
    "recommendedForMe": "我的推荐",
    "recent": "最近添加",
    "view": "查看",
    "added": "已添加",
    "more": "更多",
    "openLibrary": "前往资料库",
    "readToEarn": "阅读获取积分",
    "readArticle": "打开链接",
    "see_more": "查看更多(%{num})",
    "see_more_activities": "更多%{num}个",
    "my_achievements": "我的成就",
    "achievements": "成就",
    "achievement_earned_date": "获取日期：%{date}",
    "achievement_start_date": "开始日期：%{date}",
    "achievement_end_date": "结束日期：%{date}",
    "achievement_earned": "获取",
    "achievement_start": "开始",
    "achievement_end": "结束",
    "achievement_earned_times": "%{num}次",
    "achievement_earned_time": "%{num}次",
    "in_progress": "正在进行中",
    "date_earned": "获取日期",
    "earned": "获取",
    "past_dates_earned_heading": "过去的获取日期",
    "all": "所有",
    "eat": "饮食",
    "move": "运动",
    "feel": "感觉",
    "profile_completion": "个人资料完成情况：%{percentage}%",
    "complete_my_profile": "完成您的个人资料",
    "do_following_tasks": "完成以下%{num}个任务后，就能完成您的个人资料。",
    "improve_my_score": "提高您的分数",
    "see_which_goals": "查看您为改善饮食、运动和感觉而设定的目标。",
    "havent_set_goal": "您还没有设定目标。",
    "set_a_goal": "设定一个目标",
    "set_another_goal": "设定另一个目标",
    "set_another_goal_here": "在这里设定另一个目标。",
    "my_recently_tracked_activities": "我最近的活动",
    "a_few_seconds_ago": "几秒钟前",
    "a_day_ago": "一天前",
    "yesterday": "昨天",
    "earn": "获取",
    "delete_activity_confirmation": "您是否确定要删除该活动？",
    "delete_activity_title": "删除%{activity_name}的%{measurement}？",
    "reached_daily_goal": "您今天完成了目标。干得漂亮！",
    "multiple_activity_non_daily_instruction": "点击活动行，开始追踪并获取%{customPoints}！",
    "multiple_activity_daily_instruction": "点击加号来追踪达到目标所需的活动量。点击活动行的任何其他地方来追踪任何活动量。",
    "only_automatic_activities": "有助于实现该目标的活动只能自动追踪",
    "only_automatic_activity": "有助于实现该目标的活动只能自动追踪",
    "earn_pts_and_reach_goal": "追踪%{qty}，就能获取%{pts} pts并达成目标",
    "earn_pts_for_every": "获取%{pts} pts的依据是",
    "you_track": "追踪到1个单位！",
    "you_have_tracked": "您目前已经追踪到%{qty}",
    "so_far": "！",
    "start_goal": "设定该目标",
    "about_this_goal": "目标相关信息",
    "start_date": "开始日期",
    "end_date": "结束日期",
    "activities": "活动",
    "goal": "目标",
    "instructions": "说明",
    "daily": "每日",
    "weekly": "每周",
    "monthly": "每月",
    "total": "总计",
    "week": "周",
    "day": "天",
    "days": "天",
    "month": "月",
    "months": "月",
    "progress": "进度",
    "about": "简介",
    "days_remaining_to_track": "您有%{num}天的时间来追踪任何错过的活动",
    "number_days": "%{num}天",
    "one_day": "1天",
    "points_earned_this_week": "本周获取的积分",
    "points_earned_year": "本年至今获取的积分",
    "completed": "已完成",
    "what_you_need_to_do": "您需要做什么",
    "see_all_num": "查看所有%{num}",
    "my_week_progress": "您的每周进度",
    "my_day_progress": "您的每日进度",
    "my_month_progress": "您的每月进度",
    "my_total_progress": "您的总进度",
    "my_overall_progress": "总体进度",
    "you_earned": "您获取了",
    "of_this_week": "%{num}的本周积分",
    "of_this_day": "%{num}的今日积分",
    "of_this_month": "%{num}的本月积分",
    "of_this_total": "%{num}的总计积分",
    "of_this_overall": "%{num}的总体积分",
    "remaining_this_week": "本周剩余",
    "remaining_this_month": "本月剩余",
    "remaining_this_total": "剩余",
    "remaining_this_overall": "总体剩余",
    "view_history": "查看历史记录",
    "this_goal_is": "该目标是",
    "will_run_for": "将会运行",
    "button_unset_goal": "取消目标",
    "button_leave_challenge": "离开挑战",
    "leaveChallenge": {
        "menu": "离开%{challengeName}"
    },
    "deleteChallenge": {
        "menu": "删除%{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已取消该个人目标。"
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已离开该挑战。"
        }
    },
    "activities_tracked": "追踪的活动",
    "recently_tracked_activities": "最近追踪的活动",
    "add": "添加",
    "change_before_track": "您似乎没有做任何更改。编辑这一天的活动量，或者不做修改直接退出。",
    "havent_tracked_today": "您似乎还没有追踪这一天的任何活动。从搜索活动开始。",
    "cancel_tracking_quantity": "取消追踪%{quantity}的%{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "退出将放弃您对活动历史的编辑。您是否确定？",
    "discard_activity_edits_confirmation_date": "退出将放弃您对%{date}活动历史的编辑。您是否确定？",
    "yes_discard_edits": "是，退出并放弃编辑的内容",
    "createGoal": {
        "navigatorTitle": "创建个人目标",
        "navigatorSubtitle": "第%{step}步，共4步"
    },
    "allCommunities": "一切",
    "deleteCommunityDescription": "您是否确定删除该社区？",
    "remaining": "剩余",
    "recommended_goal": "推荐的目标",
    "pinError": "PIN %{pin}无效。请再试一次。",
    "previousPersonalGoals": "我已完成的个人目标",
    "previousGoalsTitle": "我之前的目标",
    "endedOn": "结束于",
    "achievedOfGoal": "您实现了%{num}%的目标",
    "previousGoalsEmptyMessage": "您没有之前的目标",
    "emptyListDefaultMessage": "您在此处没有任何项目",
    "myCommunitiesEmpty": "您似乎还没有加入任何社区。加入社区，与他人互动并分享您的旅程。",
    "discoverMoreCommunities": "发现更多社区",
    "howLong": "持续时间",
    "frequency": "频率",
    "discard": "放弃",
    "description": "描述",
    "optional": "可选",
    "instruction": "说明",
    "name": "名称",
    "create": "创建",
    "categories": "类别",
    "uploadPhoto": "添加照片",
    "delete_goal": "删除该%{name}",
    "delete_goal_confirmation": "您是否确定删除该目标？",
    "leave_goal_confirmation": "您是否确定离开该挑战？",
    "creatingCustomGoalToast": {
        "success": {
            "message": "已创建您的目标。"
        }
    },
    "defaultSelectMessage": "请选择一个选项",
    "search": "搜索",
    "inTotal": "总计",
    "State": "州",
    "Business unit": "业务单位",
    "Work location": "工作地点",
    "whenStart": "您想什么时候开始？",
    "every": "每个",
    "acceptChallenge": "接受挑战",
    "activity_history_challenge": "挑战的活动历史",
    "havent_tracked_challenge": "您还没有追踪过该挑战的任何活动",
    "earned_lowercase": "获取",
    "noone_tracked_yet": "还没有人追踪过任何活动。开始追踪，在比赛中保持领先地位！",
    "you": "您",
    "your_team": "我的团队",
    "congrats_first_place": "祝贺您获得了第一名！ 继续努力。",
    "leader": "领先者",
    "average": "平均",
    "show_leader": "显示领先者",
    "show_me": "显示本人",
    "show_my_team": "显示我的团队",
    "leaderboard": "排行榜",
    "my_team": "我的团队",
    "remaining_to_track": "还在追踪",
    "avg": "平均",
    "invite": "邀请",
    "team_members": "团队成员",
    "daysLeft": "天剩余",
    "regionNameLiveBetter": "州",
    "locationNameLiveBetter": "工作地点",
    "departmentNameLiveBetter": "业务单位",
    "regionLabelLiveBetter": "选择州",
    "locationLabelLiveBetter": "选择工作地点",
    "departmentLabelLiveBetter": "选择业务单位",
    "companyLocation": "工作地点",
    "no_location": "没有地点",
    "connect": "连接",
    "syncing": "正在同步",
    "sync": "同步",
    "havent_tracked_in_a_while": "没有最近追踪的活动",
    "contact": "联系",
    "manage": "管理",
    "creator": "创建者",
    "allow_notifications": "管理通知",
    "enable_notifications": "开启通知",
    "appload": "请稍等片刻，{app_name}正在更新……",
    "sendResetEmail": "发送重置邮件",
    "min": "最小",
    "max": "最大",
    "error_joining_team": "无法加入团队",
    "cannot_add_to_team": "糟糕……我们将您加入该团队时出现了问题。可能是该团队已经达到了成员最大数量，或者已经不存在了。如果发生其他错误，请再试一次。",
    "members_needed": "需要%{num}名成员",
    "member_needed": "需要%{num}名成员",
    "spots_left": "还剩%{num}个名额",
    "join": "加入",
    "no_teams_create": "目前没有任何团队可供您加入。何不自己创建一个？",
    "number_teams": "%{num}个团队",
    "youLowercase": "您",
    "joined_challenge_on_team": "您已通过团队%{team_name}参与挑战。",
    "join_team": "加入一个团队",
    "former_members": "之前的成员",
    "letsGo": "开始吧",
    "invite_to_team": "邀请加入团队",
    "connectingDeviceToast": {
        "success": {
            "title": "连接应用程序或设备",
            "message": "成功！您的应用程序或设备已连接。"
        },
        "danger": {
            "title": "连接应用程序或设备",
            "message": "糟糕……我们在连接该服务时遇到了问题。请再试一次。"
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "断开应用程序或设备的连接",
            "message": "您已经成功断开了%{name}的连接。"
        },
        "danger": {
            "title": "断开应用程序或设备的连接",
            "message": "糟糕……我们在断开%{name}的连接时遇到了问题。请再试一次。"
        }
    },
    "leave_entity_question": "离开%{name}？",
    "delete_entity_question": "删除%{name}？",
    "leave_team_challenge_confirmation": "您是否确定在该挑战中离开%{name}？",
    "leave_last_team_member": "作为该团队的最后一名成员，离开挑战将删除团队。",
    "oops_msg": "糟糕……在尝试完成此操作时出现了错误。请再试一次。",
    "has_been_created": "您已经通过团队%{name}参加挑战。",
    "specify_team_name": "请取一个团队名",
    "invite_members": "邀请成员",
    "upload_photo_no_question": "添加照片",
    "my_progress": "我的进度",
    "rewardsPointsAdditionalInfo": "每%{period}每达到一个等级，就能获取%{reward_currency}。您的%{customPoints}和等级每%{period}都会重置，因此，即使您在上期达到最高等级，您也有机会继续获取%{reward_currency}。",
    "rewardsPointsInfo": "您的%{customPoints}和进度每%{period}都会重置。",
    "departments": "部门",
    "regions": "地区",
    "noItemsSelected": "没有选择项目",
    "pleaseSelectOne": "请从列表中选择至少一个项目",
    "tracked": "已追踪",
    "starts": "开始",
    "duration": "持续时间",
    "bonus": "奖励",
    "invited_by": "邀请人",
    "create_team": "创建团队",
    "discardConfirmation": "您是否确定退出？",
    "discardYes": "是",
    "discardStay": "返回",
    "create_team_toast_title": "创建团队",
    "edit_team": "编辑团队",
    "team_edits_submitted": "您的团队已更新。",
    "challenge_ended_still_trackable": "该%{type}已结束，幸运的是您还有%{num}天可以追踪！",
    "tracking_period_ended": "该%{type}的追踪周期已结束。",
    "unlimited": "无限制",
    "ends_in": "结束于",
    "challenge_toast": {
        "success": {
            "join": "成功！",
            "message": "您已成功加入挑战。"
        },
        "danger": {
            "error": "错误",
            "message": "出错了。请一会儿再试着加入挑战。"
        }
    },
    "members_to_invite": "邀请的成员",
    "members_to_remove": "删除的成员",
    "myChallenges": "比赛",
    "upcoming": "即将开始",
    "myPersonalGoals": "目标",
    "companyCompetitions": "公司比赛",
    "communityCompetitions": "社区比赛",
    "edit_your_team": "编辑您的团队",
    "emails": "电子邮箱",
    "CompletedOverall": "总体完成量",
    "TotalEarned": "获取总数",
    "notify_header": "我希望得知：",
    "AdditionalBonus": "额外奖励",
    "goalEndedNotification": "目标结束了，继续鞭策自己！",
    "compEndedNotification": "比赛结束了，继续鞭策自己！",
    "congrats_tracking_first": "祝贺您成功追踪自己的第一个活动！",
    "keep_tracking": "继续追踪活动，从而实现目标和提高等级。",
    "understanding_tracking": "了解追踪",
    "cannot_track_this_day": "您在这一天不能追踪。",
    "nothing_tracked_this_day": "您在这一天还没有追踪。",
    "tracked_something_this_day": "您在这一天已经追踪了内容。",
    "reached_goal_this_day": "您在这一天已经达成目标（只针对每日目标）。",
    "got_it": "明白了！",
    "notDismissedMultiTitle": "挑战总结",
    "notDismissedMultiSubtitle": "有几项挑战已结束。深入了解每项挑战的详细信息，看看自己的表现。",
    "daySummary": "%{userName}，这是您到目前为止的总结",
    "goals": "目标",
    "competitions": "比赛",
    "totalAccumulated": "累计总数",
    "tracking_for_date": "追踪%{date}的活动",
    "activity_tracker_instruction": "点击编辑或删除手动追踪的活动",
    "ended": "已结束",
    "notYetAvailableBeta": "在测试版中尚不可用",
    "suggestedGoal": "建议的目标",
    "singleFor": "对于",
    "seeLessLongComment": "查看更少",
    "synced_data": "同步数据：",
    "doThisLater": "我之后再进行",
    "inviteUsers": "邀请其他人加入",
    "cannotTrackAfterDeadline": "您希望在挑战截止日期后的日期追踪活动。",
    "potentialBonusPoints": {
        "section": {
            "title": "完成该目标可获得%{potentialBonusPoints}奖励%{customPoints}！",
            "titleNotCompleted": "您错过了%{activitytCompletedPercentage}%完成度的%{potentialBonusPoints}奖励%{customPoints}。",
            "titleCompleted": "祝贺您！ 您获取了",
            "titleCompletedBold": "%{potentialBonusPoints}奖励%{customPoints}！",
            "subtitle": "了解更多关于奖励%{customPoints}的信息"
        },
        "modal": {
            "title": "奖励%{customPoints}",
            "desc1": "我们知道，世上无完人，很难100%完成自己的目标。",
            "desc2": "这就是为什么当您的总体进度达到85%或以上时，我们就会给予奖励%{customPoints}。",
            "desc3": "所有的奖励%{customPoints}都是在目标结束后发放的，如果您的所有追踪都来自连接的应用程序或设备，您将获得双倍的奖励%{customPoints}！",
            "desc4": "如果您提前离开目标，您将不会获得奖励%{customPoints}。"
        },
        "msg": {
            "title": "此目标已结束",
            "subtitle": "目标于%{goalEndedDate}结束"
        },
        "msgEnded": {
            "title": "时间到了！ 您的目标已结束",
            "subtitle": "您有%{daysNum} %{daysOrDay}来追踪您的活动。"
        }
    },
    "finish": "完成",
    "personalGoal": {
        "all_goals": {
            "selected": "已设定所有%{maxGoals}个目标！",
            "description": "这是否符合您的心意？如果改变主意，您可以替换任何目标。别担心，您之后可以取消目标。",
            "set": "已设定所有目标！",
            "action": "万事俱备，开始大展身手吧！",
            "error": "不要太贪心！ 一次最多专注3个结构合理的目标，这会增加您成功的几率。",
            "errorHeading": "设定目标"
        },
        "set_more": "您可以再设定%{maxGoals}个活跃目标",
        "select_goal": {
            "heading": "设定推荐目标或创建您自己的目标"
        },
        "set_more_1": "您可以再设定一个活跃目标"
    },
    "restartPersonalGoal": "用新的小目标重启大目标",
    "delete_challenge_confirmation": "您是否确定删除该挑战？",
    "personal_goal_unit": "目标",
    "personal_goal_units": "目标",
    "day_summary": {
        "steps_taken": "步数",
        "calories_in": "卡路里摄入量",
        "calories_out": "卡路里消耗量",
        "avg_daily": "每日平均数",
        "most_earned_daily": "一天最多获取量"
    },
    "invitedBy": "受%{person}邀请",
    "resetPasswordMissingField": "请输入电子邮箱",
    "resetPasswordInvalidValue": "请输入一个有效的电子邮箱",
    "resetPasswordNotFound": "无法找到您的电子邮箱",
    "resetPasswordNotCompleted": "您的申请无法完成",
    "resetGoalInstructions": {
        "start": "%{frequency}完成%{quantity} %{units} 的 %{activity}",
        "additional": "，%{quantity} %{units} 的 %{activity}",
        "end": "并%{frequency}获取%{points} %{customPoints} "
    },
    "goalSet": {
        "one": "设定一个目标。查看",
        "two": "设定两个目标。查看",
        "three": "设定三个目标。查看",
        "none": "没有设定目标。设定目标"
    },
    "searchCommunitiesEmpty": "没有找到社区",
    "searchCommunitiesPlaceholder": "搜索社区",
    "updating": "正在更新……",
    "pts_tracked": "追踪%{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "继续努力，您就能提高自己的健康分数。",
    "progressHistory": "进度记录",
    "privateCommunity": "这是一个私人社区",
    "do_combo_of_activities": "任意组合下列项目。",
    "noActivitiesTracked": "没有追踪的活动",
    "trackingWithFollowingApps": "使用以下应用程序\/设备进行追踪",
    "recommendedApps": "该%{challengeType}的推荐应用程序\/设备",
    "collapseWord": "崩溃",
    "started": "已开始",
    "ends": "结束",
    "do_activities": "进行活动",
    "rewards_placeholder": "商店的奖励示例，占位符。用户将看到他们可以购买的各种产品和%{rewardName}的费用。",
    "personalGoals": {
        "top": {
            "label": "顶部"
        },
        "allGoals": "所有目标",
        "seeMoreCard": {
            "heading": "没有看到您要找的内容？",
            "description": "看看所有推荐目标",
            "button": "探索目标"
        }
    },
    "rewardsNotAvailable": "奖励目前在该测试版中还不能使用。当可以使用时，您就能够查看目录并完成兑换。",
    "editProfileProvideRestingHeartRate": "请提供有效的静态心率值，至少为40",
    "liveBetterHealthInfo": "我们开展了许多计划，并有各种健康内容，满足一系列健康需求，帮助您改善健康状况。我们还未能针对每种健康状况和需求制定特殊计划，但我们正在不断努力！- 但是，如果您回答了以下问题，我们就能在发现任何适合您参与的健康计划或服务时，及时与您联系，和\/或向您发送实证信息，帮助您更好地了解和管理自己的健康需求。请注意，我们不会用这些信息来评估您的保单是否符合要求。如果您想了解自己的保险范围或对您的保单有任何疑问，可以致电我们的客户联系团队，电话是132 331。",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已删除目标"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已删除挑战"
        }
    },
    "invitations": "邀请",
    "learnMorePeriods": "了解更多关于周期的信息",
    "tracked_by_app_name": "由%{app_name}追踪",
    "device_required": {
        "text": "该%{challengeType}需要应用程序或设备",
        "button": "连接应用程序或设备"
    },
    "editingCommunityToast": {
        "success": {
            "title": "编辑社区",
            "message": "社区已编辑"
        }
    },
    "competition": "比赛",
    "close": "关闭",
    "only_automatic_activities_with_device": "该%{goal_or_competition}的活动会由您连接的应用程序\/设备自动追踪。",
    "only_automatic_activity_with_device": "该%{goal_or_competition}的活动会由您连接的应用程序\/设备自动追踪。",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "社区已删除"
        }
    },
    "teamSizeMessage": "您的团队至少需要%{min}人，才能获得挑战的%{customPoints}。",
    "captain": "队长",
    "inviteOthersToTeam": "邀请他人加入我的团队",
    "loadingMetrics": "连接到来源以更新您的每天……",
    "aboutTeamSize": {
        "title": "团队人数",
        "text": "%{min}到%{max}"
    },
    "pointsOverview": "%{customPoints}概述",
    "deepLinks": {
        "requestCouldNotBeCompleted": "您的申请无法完成",
        "error": "错误"
    },
    "required_lc": "需要",
    "personal": "个人详细资料",
    "biometrics": "生物统计学",
    "makeSelection": "进行选择",
    "ask_question_success_msg": "非常感谢。我们会尽快答复。",
    "report_issue_success_msg": "非常感谢。我们会尽快答复。",
    "ask_question_success_title": "提交的问题",
    "report_issue_success_title": "提交的技术问题",
    "ask_question_failure_msg": "很遗憾……提交您的问题时出现了错误，请再试一次。",
    "report_issue_failure_msg": "很遗憾……报告您的问题时出现了错误，请再试一次。",
    "notTrackedActivities": "您在该周期内没有追踪任何活动",
    "learn": "学习",
    "Balance": "余额",
    "details": "详细信息",
    "Reward": "奖励",
    "levelsReset": "%{remainingDays}后重置等级",
    "redeem": "兑换",
    "redeemAt": "以%{points}兑换",
    "needPointsToRedeem": "您还需要%{points}的%{rewardName}。",
    "learnEarnMore": "了解如何获取更多",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "加入团队",
            "message": "您已成功加入团队！"
        },
        "danger": {
            "message": "我们遇到了错误，无法找到该团队。它可能已经不存在。"
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "不可操作",
            "message": "您的申请无法完成。"
        }
    },
    "transactionLog": "交易",
    "orderHistory": "订单",
    "pointsAvailableToEarn": "可获取%{points}",
    "missedYTD": "年初至今错过了%{missed} ",
    "rewardsDetails": "奖励",
    "successfullyRedeemedItem": "您已成功兑换了该物品",
    "orderNumber": "订单号",
    "amountSpent": "花费金额",
    "status": "状态",
    "dateRedeemed": "兑换日期",
    "additionalInformation": "其他信息",
    "shipToAddress": "邮寄地址",
    "pointMissedYearToDate": "今年错过了%{rewardCurrencyName}",
    "pointMissedYearToDateDescription": "如果您在周期结束前没能达到某个等级，您就会错过本可以获得的相关%{rewardCurrencyName}。",
    "NoLibraryContentToast": {
        "info": {
            "title": "未找到文章",
            "message": "无法找到文章。它可能已删除或不再可用。"
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "未找到社区",
            "message": "无法找到社区。它可能已删除或不再可用。"
        }
    },
    "shippingAddress": "运输\/账单地址",
    "enterShippingAddress": "输入您的运输\/账单地址",
    "streetLine": "街道行%{num}",
    "stateProvince": "州\/省",
    "postcodePostalcodeZip": "邮政编号",
    "phoneNumber": "电话号码",
    "order": "订单",
    "redemptionConfirmation": "兑换确认",
    "edit": "编辑",
    "processing": "处理中",
    "checkIsYouFirst": "我们只需要先确认这是否为您第一次",
    "discardSomeGoals": "您已设定了一些目标。如果继续，您将放弃这些目标。",
    "settingGoalsToast": {
        "success": {
            "message": "您已设定新目标！"
        }
    },
    "one_team": "1个团队",
    "noAchievementsToEarnMessage": "本周期似乎没有徽章可以获取%{rewardCurrencyName}。",
    "shopRewards": "购物奖励",
    "validateShippingAddressToast": {
        "danger": {
            "title": "运输\/账单地址",
            "message": "请在继续之前填写所有字段。"
        }
    },
    "viewDetails": "查看详情",
    "potential": "潜在的",
    "missed": "错过的",
    "rewardsStoreNotAvailable": "奖励商店目前无法向您开放。",
    "havent_tracked_in_a_while_date": "%{currentDate}没有追踪活动",
    "challengeNotFoundToast": {
        "danger": {
            "title": "未找到挑战",
            "message": "无法找到挑战。它可能已删除或不再可用。"
        }
    },
    "shareYourDaySubtitleActivity": "添加图片或对该活动发表看法！",
    "goal_ended": "目标结束",
    "challenge_ended": "挑战结束",
    "day_remaining_to_track": "您有1天的时间来追踪任何错过的活动",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal}结束于%{endDate}",
    "goalEndedModal": {
        "title": "补追踪忘记的活动",
        "message": "个人目标或挑战结束后，您有三天时间来追踪您忘记的活动。过了这个宽限期，您就不能再追踪有助于实现目标或挑战的任何额外活动。"
    },
    "summary": "总结",
    "placedRank": "您在%{total}中排名第%{rank}",
    "rank": {
        "first": "第1名",
        "second": "第2名",
        "third": "第3名",
        "n": "第%{rank}名"
    },
    "event_name": "活动名称",
    "this_is": "这是",
    "location_info": "地点和信息",
    "what_event": "该活动是关于什么的",
    "event_is": "该活动是",
    "start_on": "开始日期：",
    "end_on": "结束日期:",
    "location": "地点",
    "chooseLeaderboard": "选择排行榜",
    "filterOneOfFollowing": "筛选以下内容之一",
    "showChallengeInstead": "显示挑战",
    "showActivityInstead": "显示活动",
    "showAll": "显示全部",
    "activitiesShowSame": "活动：%{activityName}",
    "challengeShowSame": "挑战：%{challengeName}",
    "chooseTimePeriod": "选择一个时间段",
    "youCanFilterOneAtTime": "每次可选择一个过滤器",
    "saveHealthTopicsToast": {
        "success": {
            "message": "已保存的健康主题",
            "title": "成功！"
        },
        "info": {
            "message": "无法保存"
        },
        "danger": {
            "title": "错误！"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "已保存的健康目标",
            "title": "成功！"
        },
        "info": {
            "message": "无法保存"
        },
        "danger": {
            "title": "错误！"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "已保存的兴趣爱好",
            "title": "成功！"
        },
        "info": {
            "message": "无法保存"
        },
        "danger": {
            "title": "错误！"
        }
    },
    "edit_event": "编辑活动",
    "leave": "离开",
    "delete_event": "删除活动",
    "no_events": "没有活动",
    "no_events_placeholder": "您目前没有计划参加任何未来活动。何不加入一个？",
    "event": "活动",
    "challenge": "挑战",
    "invited_you": "已邀请您",
    "public": "公开",
    "private": "私密",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "活动已成功删除。"
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "您已离开活动"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "活动更新成功。"
        }
    },
    "createEventToast": {
        "success": {
            "message": "活动创建成功。",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "您希望查看的内容目前不可用。它可能已被作者删除或被他人标记为不良。",
    "start_time": "开始时间",
    "end_time": "结束时间",
    "event_type": "%{eventType}活动",
    "leave_event_modal": {
        "title": "如果您离开该活动",
        "message": "它将被删除"
    },
    "leave_event ": "您是否确定离开该活动？",
    "create_event": "创建活动",
    "created_by": "创建者",
    "eventActionToast": {
        "danger": {
            "title": "错误",
            "message": "出错了。"
        }
    },
    "continue": "继续",
    "wantExitTour": "您是否确定要退出引导？",
    "exitTour": "退出引导",
    "deleveEventPopup": "您是否确定删除该活动？",
    "attendeesTitle": "参与者",
    "userEvents": "%{name}的活动",
    "createEventIndicator": "创建活动",
    "inviteToEvent": "邀请参加活动",
    "noDescription": "没有任何描述。",
    "leaderboardIsEmpty": "该排行榜为空，或者您可能需要追踪所选时间段内的活动才能查看",
    "notParticipantingInAnyChallenges": "您没有参加任何挑战",
    "buttonLeaveEvent": "离开活动",
    "leaveEvent ": "离开%{name}？",
    "canceledCreatingChallenge": "已成功取消创建%{challengeType}",
    "swipeReadNotification": "阅读",
    "productTour": {
        "initialScreen": {
            "title": "欢迎来到%{programName}！",
            "body": "进行引导后，您很快就能掌握基本情况。"
        },
        "dashboard": {
            "title": "控制面板",
            "body": "查看您有多少%{pointsName}，以及您的等级进度。然后查看排行榜，了解自己的排名情况。"
        },
        "rewards": {
            "title": "奖励",
            "body": "看看您有多少%{rewardPointName}，并在商店里兑换。"
        },
        "goals": {
            "title": "目标和挑战",
            "body": "在这里可以找到您的活跃个人目标、与他人的挑战以及特殊任务。"
        },
        "explore": {
            "title": "探索",
            "body": "与他人一起寻找挑战，加入社区讨论自己的兴趣，并在健康资料库中发现新文章。"
        },
        "me": {
            "title": "我的信息",
            "body": "在这里可以找到您的健康分数，查看您的统计资料，并编辑您的个人资料和设置。"
        },
        "finishScreen": {
            "title": "您已经准备好了",
            "body": "感谢您完成了这次引导。",
            "button": "让我们开始吧"
        },
        "skip": {
            "title": "您是否确定要跳过引导？",
            "body": "这将结束引导，让您立即开始。"
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "认证失败",
            "message": "无法继续进行奖励兑换。在认证奖励提供者时发生了错误。"
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "兑换失败",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "开始前准备",
    "disclamerSectionMessage": "在开始任何新锻炼计划或改变生活方式之前，请向您的医疗保健专家咨询，以确保它们的适宜性。",
    "noEarchedAchievements": "您还没有获得任何成就。从追踪活动开始。",
    "noInProgressAchievements": "您没有正在进行的成就。",
    "discardCreatingEventMessage": "请检查是否已输入所有必填字段",
    "discardCreatingEventTitle": "无法创建活动",
    "discardEditedEventTitle": "无法编辑活动",
    "errorEventNameMessage": "名称为必填项",
    "errorEventStartDateMessage": "开始日期为必填项",
    "errorEventEndDateMessage": "结束日期为必填项",
    "errorEventDateMessage": "结束日期不能早于开始日期",
    "noAccountsToLink": "没有可用的账户可链接至%{program_name}。",
    "accountLinkEmailChanged": "您的电子邮箱已更新。今后，请使用您的链接账户登录。",
    "accountLinkSuccessful": "您的账户已成功链接。",
    "edit_profile_nan_value": "该值必须为数字",
    "advancedLogIn": "高级登录",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "兑换失败",
            "message": "订单会话已过期。请重新下单。"
        }
    },
    "left": "离开",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "目前似乎没有可加入的活动。何不自己创建一个？"
        }
    },
    "reachedHighestLevel": "您已达到最高等级！",
    "error": "错误",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "奖励兑换",
            "message": "您的订单已下达"
        }
    },
    "redeemRewardComplete": "兑换完成",
    "trackActivityTitle": {
        "oneUnit": "追踪：1%{unit}的%{activity}，日期为%{date}",
        "nUnit": "追踪：%{date}的%{activity}"
    },
    "ssoAuthenticationFailure": "认证失败",
    "earnEvery": "每%{frequency}获取一次",
    "earnOnce": "仅获取一次",
    "goalSettings": {
        "maximumSet": "您目前最多可以设定3个目标。",
        "learnMore": "了解更多关于目标设定的信息"
    },
    "allowMarketingComms": "向我发送促销邮件",
    "allowPartnerMarketingComms": "向我发送合作伙伴的促销邮件",
    "noUpcomingAchievements": "您没有即将开始的成就。",
    "settingGoalToast": {
        "success": {
            "message": "您已设定新目标！"
        }
    },
    "authentication": {
        "saml": {
            "error": "服务目前不可用",
            "signin": "综合登录",
            "signup": "综合注册"
        }
    },
    "monthName": {
        "january": "一月",
        "february": "二月",
        "march": "三月",
        "april": "四月",
        "may": "五月",
        "june": "六月",
        "july": "七月",
        "august": "八月",
        "september": "九月",
        "october": "十月",
        "november": "十一月",
        "december": "十二月"
    },
    "promotedForMe": "特色",
    "appRating": {
        "enjoying": "喜欢我们的应用吗？",
        "feedback": "您是否希望提供一些反馈？",
        "appStore": "在App Store给我们打分了吗？",
        "googlePlay": "在Google Play上给我们打分了吗？",
        "notReally": "不太喜欢",
        "yes": "是的！",
        "sure": "当然",
        "noThanks": "不了，谢谢",
        "notNow": "现在不行"
    },
    "getMobileApp": "如需在您的智能手机上使用%{programName}，请从App Store或Google Play下载%{appStoreName}。",
    "newAppsDevicesDesign": {
        "getMobileApp": "下载%{programName}应用程序",
        "searchInAppStore": "在您设备的应用商店中搜索 %{programName}",
        "getMobileAppNoName": "获取移动应用程序"
    },
    "editorAlert": {
        "discardChanges": "放弃更改",
        "saveAndContinue": "保存并继续",
        "title": "未保存的更改",
        "text": "您所做的部分更改没有保存。您想要做什么？"
    },
    "resources": "资源",
    "noResources": "没有可用资源",
    "viewAllResources": "查看所有资源",
    "language": "语言",
    "eventStarted": "活动开始。注册结束。",
    "Gender": "性别",
    "show": "显示",
    "hide": "隐藏",
    "timeoutError": "糟糕！有些步骤花了太长时间。请稍后再试。",
    "SOT": {
        "sample_task": "任务示例"
    },
    "cache": {
        "new_version": "已经推出新的版本！",
        "refresh_browser": "点击此处刷新您的浏览器。"
    },
    "welcomeUser": "%{userFirstName}，欢迎加入我们！",
    "quarter": "季度",
    "completionReward": "完成奖励",
    "bronzeLevel": "青铜等级",
    "deviceAppSyncingOk": "设备\/应用程序同步完成",
    "deviceAppSyncingIssue": "设备\/应用程序同步问题",
    "deviceAppSyncingError": "设备\/应用程序同步错误",
    "lastSync": "最近一次同步",
    "period": "周期",
    "yourDaySummary": "至今的体验",
    "steps": "步骤",
    "gender_non_binary": "非二进制或不合格",
    "take_survey": "参加问卷调查",
    "social": "社交",
    "finalDay": "最后一天",
    "leaderboard_position": "榜单排名",
    "signUp": {
        "apple": {
            "disconnectSettings": "为了继续注册，请在手机设置中的“Apple ID 密码与安全”断开%{appName}连接"
        }
    },
    "earnPoints": "获取%{customPoints}。提升等级。",
    "getReward": "获得%{rewardName}。",
    "buildHealthyHabits": "培养健康的生活习惯。",
    "highestLevelIndicator": "您已达到最高等级！",
    "highestLevelIndicatorNew": "您已达成所有等级！",
    "trackYourActivity": "为了获取%{customPoints}，请追踪您的运动和健康活动。",
    "levelUpToGetRewarded": "随着等级的提升，您会得到%{rewardName}奖励。",
    "levelUpAndEarn": "您的进度每%{period}会重置一次，因此您可以反复提升等级和获得奖励。",
    "levelUp": "您的进度每%{period}会重置一次，因此您可以反复提升等级。",
    "goToLibrary": "前往资料库",
    "updateEventIndicator": "更新活动",
    "meTour": {
        "healthSurveyDisabled": "查看您的统计资料，并在此编辑您的个人资料和设置。"
    },
    "createNewGoal": "创建新目标",
    "later": "稍后",
    "bonusChallenge": "奖励挑战",
    "bonusChallengeInfo": {
        "withReward": "该%{challengeType}至少完成85%后，您将获得%{amount}奖励%{points}。",
        "noReward": "该挑战至少完成85%后，您将获得奖励。",
        "boldText": "%{amount}奖励%{points}",
        "noRewardChallengeType": "该%{challengeType}至少完成85%后，您将获得奖励。"
    },
    "defaultApp": "您的默认健康应用程序",
    "bonusGoal": {
        "additionalInfo": "如果您的所有活动都由连接的应用程序或设备追踪，您将获得双倍的奖励%{points}！",
        "additionalInfoNew": {
            "paragraph2": "奖励%{points}在目标结束后发放。如果您提前离开目标，您将无法获得奖励%{points}。"
        },
        "boldText": "双倍奖励%{points}！",
        "markTitle": "奖励目标"
    },
    "notify_me": "通知我",
    "bonusChallengeReward": "奖励挑战的收益",
    "forCompletingChallenge": "因为完成了%{challengeName}",
    "notifications_text": "通知能帮助您坚持目标并及时收到消息。",
    "type_here": "在此输入",
    "bonusEarned": "赢得的奖励",
    "youEarnedBonus": "您赢得了该奖励！",
    "inviteOthersToChallenge": "邀请他人加入挑战",
    "inviteOthersToYourTeam": "邀请他人加入您的团队",
    "manageTeam": "管理团队",
    "ft": "英尺",
    "lbs": "磅",
    "cm": "厘米",
    "kg": "公斤",
    "community": "社区",
    "chooseActivity": "选择活动",
    "Recent": "最近",
    "noActivities": "没有匹配的活动",
    "photoChooseText": "选择",
    "photoCancelText": "取消",
    "signIn": {
        "missingEmail": "缺少电子邮箱",
        "missingPassword": "请确保提供密码",
        "invalidLogin": "无效登录",
        "accountLocked": "您的账户已被锁定。请联系您的管理员",
        "accountMayNotExist": "该电子邮箱没有绑定账户。请注册并创建账户。",
        "wrongPassword": "错误密码。重试，或点击“忘记密码”重设密码。"
    },
    "deleteGoalBonusPoints": "如果您还没有获得相关的奖励，您将无法再获得。",
    "havent_tracked_goal": "您还没有追踪该挑战的任何活动",
    "trackActivity": {
        "search": "搜索活动……",
        "text": "追踪活动",
        "done": "完成",
        "discardChanges": "放弃更改？",
        "discardMessage": "您是否确定要退出并放弃您的进度？",
        "discard": "放弃",
        "limitMessage": "您一次最多只能追踪七天。",
        "inputDescription": "%{date}的%{activity}量",
        "gracePeriod": "您有%{n} %{text}来追踪任何错过的活动"
    },
    "dates": "日期",
    "pickDates": "选择其他日期",
    "selectDates": "选择日期",
    "limitReached": "您已达到限值",
    "activity": "活动",
    "keepUpTheGoodWork": "继续努力！",
    "activityTracked": "追踪的活动",
    "new": "新的",
    "newFeatureTitle": "更便捷和更快速的活动追踪",
    "newFeatureText": "无论是追踪今天的活动，还是过去的活动，又或是多天的活动，您都会爱上我们这种全新体验。",
    "gotIt": "明白了！",
    "frequencyViewHistory": "查看%{frequency}明细",
    "challengeDetails": {
        "trackTheseActivities": "追踪这些活动，逐渐达成%{challengeType}。"
    },
    "member": "会员",
    "weeklyBreakdown": "每周明细",
    "setGoals": {
        "earnPointsText": {
            "start": "获取",
            "end": "设定第一个目标的积分!"
        }
    },
    "weeklyGoalEnded": "一周结束于",
    "weekFinished": "您完成了一周的",
    "restartGoal": {
        "daysLeftToTrack": "您仍然有%{quantity} %{days} 来追踪上周忘记的进度。",
        "weekEnded": "本周已结束。",
        "timesUp": "时间到了！",
        "period": {
            "title": "目标周期",
            "text": "周一至周日，每周"
        }
    },
    "membersPlural": "会员",
    "startedADayAgo": "1天前开始",
    "goalRestarted": "该目标已重新开始",
    "weeklyGoals": "每周目标",
    "weeklyGoalsDescription": "每周目标会在周一更新，所以您可以长期保持健康的习惯。",
    "challengeEnded": "该%{challengeType}已结束",
    "goalEndedModalTitle": "时间到了！ 您的%{challengeType}已结束！",
    "yourProgress": "您的进度",
    "earn_withRewards": "跟踪您的健康活动以获得 (%{pts}) 并通过级别。当您升级时，您将获得%{currency}。",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "当前周期",
    "currentScore": "当前分数",
    "viewActivityLog": "查看活动记录",
    "balanceHistory": "我的余额历史",
    "mymedibank": {
        "underAge": {
            "error": "Live Better应用程序仅面向18岁及以上的用户，更多信息请参考Live Better条款和条件。"
        }
    },
    "enhancedHomePageInfo": "我们对主页进行了整理！ 现在可以更容易找到您的挑战和目标。开始追踪吧！",
    "levelUpTitle": "提升等级",
    "levelUpDescription": "通过追踪活动和完成目标和挑战来提升等级。随着等级的提升，您会获得%{currency}奖励！",
    "achievementsDescription": "解锁这些特殊徽章，可获取%{currency}。点击徽章，查看您需要完成的任务。",
    "bonusChallengesDescription": "加入并完成有%{currency}奖励的挑战。",
    "earnWithPartners": {
        "title": "在合作伙伴处获取",
        "description": "拥有医疗保险或附加保险的Medibank会员可通过在合作伙伴处的合格采购\/活动来获取积分。"
    },
    "browseAllPartners": "浏览所有合作伙伴",
    "resetsIn": "在%{daysNumber}天后重置",
    "thisIsALot": "这是很不错的数字！",
    "areYouSure": "您是否确定？",
    "trackingALotMessage": {
        "days": "您在%{daysNum}天内追踪超过2,000%{customPoints}。这是很不错的数字！",
        "day": "您在1天内追踪超过2,000%{customPoints}。这是很不错的数字！"
    },
    "amSure": "我确信",
    "activeMinutesAndSleep": {
        "title": "设备追踪活跃时间和睡眠",
        "description": "您的设备在中强度或高强度体育活动中记录活跃时间——这就是高质量的运动！使用设备追踪您的睡眠？您也会因此获得%{points}！"
    },
    "hourShort": "小时",
    "hoursShort": "小时",
    "secondsShort": "秒",
    "watchToEarn": "观看获取",
    "oneParticipant": "1名参与者",
    "oneTeam": "1个团队",
    "numberOfTeams": "%{num}个团队",
    "inviteToYourTeam": "邀请加入您的团队",
    "inviteToThisChallenge": "邀请参加该挑战",
    "challengeInstructionText": "追踪该活动，可取得%{challengeType}进度。",
    "showLess": "显示更少",
    "startsTomorrow": "明天开始",
    "deadlineDayLeft": "天剩余",
    "deadlineDaysLeft": "天剩余",
    "deviceBonus": "设备奖励",
    "appsAndDevices": {
        "header": "应用程序和设备",
        "linked": "这些已链接的应用程序和设备正在追踪该%{challengeType}：",
        "noLinked": "没有适用的已链接应用程序或设备",
        "link": "链接您的手机、手表或应用程序来自动追踪。"
    },
    "yourGoals": "您的目标",
    "yourChallenges": "您的挑战",
    "position": "排名",
    "team_success": "团队成功",
    "starts_in": "开始于",
    "team_challenge": "团队挑战",
    "your_progress_today": "今日进度",
    "your_daily_avarage": "您的每日平均数为",
    "this_week_progress": "本周进度",
    "this_month_progress": "本月进度",
    "overall_progress": "总体进度",
    "complete": "完成",
    "overallSuccess": "整体成功",
    "teamSuccessAverage": "团队成功平均数",
    "progressDetails": "进度详情",
    "dayStreak": "%{n}天的连胜！",
    "weekStreak": "%{n}周的连胜！",
    "dailyProgress": "每日进度",
    "participantsSuccessCount": {
        "overall": "在%{total}名参与者中，有%{amount}名已达到目标",
        "day": "今天，在%{total}名参与者中，有%{amount}名已达到目标",
        "week": "本周，在%{total}名参与者中，有%{amount}名已达到目标",
        "month": "本月，在%{total}名参与者中，有%{amount}名已达到目标"
    },
    "doubleBonusShort": "双倍奖励！",
    "doubleBonusLong": "您赢得了双倍奖励！",
    "recommendedGoalDescription": "目标可以帮助您追踪自己的进度，并保持动力！",
    "noParticipation": "没有参与",
    "nothingToShow": "现在似乎没有可展示的内容",
    "yourTeam": "您的团队",
    "no_activity_title": "没有活动",
    "brandSupport": {
        "description": "我们增加了对Polar和Withings智能手表的活动同步支持。快行动起来！"
    },
    "no_tracked_activities": "您还没有追踪任何活动。",
    "button_leave_community": "离开社区",
    "button_delete_challenge": "删除%{challengeType}",
    "button_delete_community": "删除社区",
    "button_delete_activity": "删除活动",
    "library_header_description": "原创内容为您的健康之旅提供教学和鼓励。",
    "library_searchbar": "搜索资料库……",
    "library_page_header": "原创内容为您的健康之旅提供教学和鼓励。",
    "onboarding_button_title": "我已经完成了",
    "refresh_bar": "点击此处更新",
    "content": {
        "min_read": "%{readingTime}分钟阅读"
    },
    "noMembers": "没有会员",
    "saved": "已保存",
    "forYou": "为您",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction}，截至日期为",
    "youCanEarnThisBadge": "每 %{period} 一次获得此徽章",
    "emailPreferences": "电子邮件偏好",
    "unsubscribeText": "选择不接收所有电子邮件更新",
    "savingText": "保存……",
    "wrongTryLater": "出错了。请稍后再试。",
    "preferencesSaved": "已保存的偏好",
    "recommendedForYou": "为您推荐",
    "formerMember": {
        "label": "前成员"
    },
    "selectionsFromLibrary": "特别为您定制的资料库精选",
    "goalsInfo": {
        "desc1": "专注于改善健康状况。",
        "desc2": "您已达到目标组最大数量。"
    },
    "createMyOwn": "创建自己的",
    "isAllSet": "全部准备就绪！",
    "undoLabel": "取消",
    "terms": "条款",
    "placeOrder": "下单",
    "item": "项目",
    "redeemFor": "兑换",
    "confirmYourOrder": "确认您的订单",
    "orderComplete": "订单完成",
    "redeemedFor": "已兑换",
    "orderDetails": "订单详情",
    "bonusGoalReward": "奖励目标奖励",
    "orderSummary": "订单汇总",
    "logoutSSO": {
        "title": "您已退出 %{programName}。",
        "description": "很快再见！",
        "signinAgain": "点击此处重新登录"
    },
    "nothing_to_show": "当前无可显示的内容",
    "no_saved_content": "您没有任何保存的内容",
    "restarts_every_week": "每周重新开始",
    "myGoals": "我的目标",
    "goalGallery": "目标展示栏",
    "share_smth": "与他人分享……",
    "newFeatureModal": {
        "smartGoal": {
            "title": "我们的步数目标智能化了！",
            "description": "您的每一周都过得各不相同——现在您的目标也是这样！\n 开启智能模式后，您的步数目标将会根据您在现实生活中的活动进行调整。\n 它在设定时考虑了要让您能够成功和保持健康。",
            "action": "来看看吧！"
        },
        "mePage": {
            "title": "新的我",
            "description": "我们重新设计了“我”部分，让您更轻松地找到您关心的内容 - 请查看！",
            "letsSeeBtn": "让我们来看看！",
            "llaterBtn": "也许稍后"
        },
        "bellEAP": {
            "title": "欢迎来到您的员工和家庭援助计划在线平台！",
            "description": "来看看这里有哪些工具和服务可以为您以及您符合资格的家人提供健康以及生活挑战上的支持",
            "button": "现在就连接，或随时访问快速链接页面"
        },
        "quickActivityLogView": {
            "title": " 更快捷地查看您最近的活动",
            "description": "您现在可以单击进度条来查看您的活动日志。"
        }
    },
    "goalSmartMode": {
        "title": "智能模式",
        "description": "根据您最近的活动水平获取个性化的每周目标。",
        "status": "此目标的智能模式为%{status}。",
        "infoModal": {
            "descriptionOne": "在智能模式开启的情况下，此目标下的目标将根据您最近的活动水平每周变化。",
            "descriptionTwo": "我们将会给您设定适度的挑战，以能让您取得成功为宜。",
            "instructions": ""
        },
        "settings": {
            "switch": "为我的步数目标开启智能模式",
            "description": "开启智能模式后，您将会在每周刚开始时获得新的步数目标。"
        },
        "enableSmartMode": "开启智能模式",
        "settingsModal": {
            "descriptionTurnOn": "您的步数目标将根据您的活动每周变化",
            "descriptionTurnOff": "您的步数目标将不会再每周根据您的个人情况变动"
        }
    },
    "On": "开启",
    "Off": "关闭",
    "top_posts": "置顶帖子",
    "most_recent": "最新内容",
    "browseByTopic": "按主题浏览",
    "video": "视频",
    "enable": "启用",
    "turnOff": "关闭",
    "new_post": "新帖子",
    "new_post_in": "新帖子来了",
    "dailyTarget": "每日目标",
    "dailyTargetForWeek": "周每日目标",
    "showMyActivityLog": "显示我的活动日志",
    "usersReacted": {
        "oneOther": "%{userName} 和另外 1 人",
        "multipleOthers": "%{userName} 和 %{count} 个其他人"
    },
    "reactionsModal": {
        "title": "更多庆祝方式",
        "description": "通过新的社交帖子反应为您的同事加油！"
    },
    "account": "帐户",
    "myWellbeingProfile": "我的健康档案",
    "physicalDetailsDescription": "需要此信息来计算您的健康得分",
    "wellbeingInterests": "福祉利益",
    "myWellbeingInterests": "我的健康兴趣",
    "preferredNameOptional": "首选名称（可选）",
    "basicPhysicalDetails": "基本身体细节",
    "notRegistered": {
        "infoModal": {
            "title": "我们无法找到您",
            "notInSystem": "不在我们的系统中。",
            "correctEmail": "请务必使用正确的帐户（通常是公司电子邮箱）并查看是否有错别字。",
            "emailHelp": "如想获得更多帮助，请发送电邮联络我们的支持团队"
        }
    },
    "dontHaveAccount": "还没有账号？",
    "wasThisHelpful": "这对您有帮助吗？",
    "healthScoreFeedbackModal": {
        "emojiSection": "本页面和您的健康分数的帮助作用有多大？",
        "commentSectionText": "我们可以如何改进它们？",
        "commentSectionPlaceholder": "添加评论……",
        "thankYouModal": "感谢您的反馈！"
    },
    "number_connected": "已连接%{numDevices}",
    "searchPlaceHolder": "搜索……",
    "noTeamsFound": "未找到团队",
    "join_a_challenge": "加入挑战",
    "me_page_titles": {
        "goal": {
            "singular": "目标",
            "plural": "目标"
        },
        "challenge": {
            "singular": "挑战",
            "plural": "挑战"
        }
    },
    "seeMoreText": "……查看更多",
    "adjust_entry": "请调整输入。",
    "overTracking": {
        "title": "过度追踪警告",
        "desc1": {
            "singular": "此输入将被审核。",
            "plural": "这些输入将被审核。"
        },
        "desc2": "故意过度追踪可能导致账户被吊销。",
        "button_edit": "编辑我的输入",
        "button_confirm": "照原样提交"
    },
    "oneEventAttendee": "1个参加者",
    "multipleEventAttendees": "%{num}个参加者",
    "to": "至",
    "eventBonusFull": "参加此活动，您将获得%{number} bonus %{points}。",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "您喜欢这篇文章吗？",
    "didYouLikeVideo": "您喜欢这个视频吗？",
    "tellUsMore": "告诉我们更多……",
    "thanksForFeedback": "感谢您的反馈！",
    "challengesSubtitle": "与其他参与者一起达到目标——或在游戏中致胜！",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health健康",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health虚拟护理",
    "virtualCare": "虚拟护理",
    "changePassword": {
        "telus": {
            "info": "您的密码通过您的%{telusVC}账户管理。",
            "button": "更改我的%{virtualCare}密码"
        }
    },
    "actions": "行动",
    "onAndUpcoming": "目前和即将到来的",
    "termsAndPrivacyPolicyNew": "继续即代表您同意",
    "invitedToTeam": "获邀加入%{firstName} %{lastName}的团队",
    "decline": "拒绝",
    "invitedToChallenge": "邀请人%{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "您还没有设定任何目标"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "您没有参加任何挑战",
        "buttonLabel": "探索挑战"
    },
    "menu": "菜单",
    "everyone": "每人",
    "confirmEmployeeID": "确认员工ID",
    "employeeIDNoMatch": "这些ID还不匹配",
    "hidePost": "隐藏%{ownerName}的帖子",
    "hidingUserPostToast": {
        "success": {
            "title": "用户已隐藏",
            "message": "您不会再看到这个用户的帖子。"
        }
    },
    "moderateHideUserDescription": "为此用户隐藏帖子将会从数据流中撤掉用户特定内容。",
    "startsInOneDay": "1天后开始",
    "endsInOneDay": "1天后结束",
    "endsToday": "今日结束",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "不在我们的系统中。您的输入是否正确？",
            "administrator": "如果您是新员工，我们可能还没有您的员工ID。请询问您的管理员，了解您应该何时重试一次。",
            "emailNotInSystem": "如果您是新员工，您的电子邮箱可能还没添加到我们的系统。请询问您的管理员，了解您应该何时重试一次。",
            "eligibleEmail": "不是合格的电子邮箱。您的输入是否正确？"
        }
    },
    "oneMember": "1个成员",
    "programCode": {
        "infoModal": {
            "unique": "您的公司拥有唯一的计划代码，通常会通过电邮提供给您。",
            "support": "如果您无法找到您的代码，请联络您的健康计划管理员，或发送带您的公司名称的电邮给support@sproutatwork.com。"
        },
        "instructions": "输入由您的雇主提供的计划代码以开始"
    },
    "whatsMyProgramCode": "我的计划代码是什么？",
    "enjoyApp": "享用我们的移动应用程序",
    "programCodeLabel": "计划代码",
    "createdByMembersChallenges": "由成员创建",
    "invites": "邀请",
    "recommendedContentTitle": "专门给您的资料库精选",
    "amountExchanged": "兑换金额",
    "orderStatus": "订单状态",
    "orderSuccessfulyyItemForConfirmation": "下单成功！确认已发送到%{email}。",
    "orderedOnDateText": "于%{orderCreatedTime}下单",
    "personalize": {
        "communities": {
            "title": "加入社区",
            "description": "社区将拥有共同兴趣的人们联系在一起。您可以随时加入或离开社区。"
        },
        "objectives": {
            "title": "我的目标",
            "description": "我们可以帮助您开始或保持住什么？我们将用此改进我们的推荐。"
        },
        "topics": {
            "title": "我的健康主题",
            "description": "您会看到有关您选择的主题的更多提示和方法指导。"
        }
    },
    "recommendedCardDesc": "设定最多3个目标以专注于改善您的健康",
    "accessibility": {
        "track_activity": "追踪活动",
        "cardbody": "卡片正文",
        "cardcontainer": "卡片容器",
        "cardfooter": "卡片脚注",
        "unstartedChallengeHeader": "未开始的挑战",
        "activeOrEndedChallengeWrapper": "挑战包装",
        "activeOrEndedChallengeHeader": "挑战标题",
        "goalHeader": "目标标题",
        "openOptions": "打开选项"
    },
    "teams": {
        "teamInvites": "团队邀请",
        "findTeam": "寻找团队",
        "teamFull": "团队已满员"
    },
    "deleteAccountText": "永久删除您的Sprout At Work帐户及其全部资料",
    "deleteAccountButtonTitle": "删除我的账户",
    "joinTeamActionSheetText": "加入或创建团队来参与该挑战",
    "frequencyNone": "无",
    "quickLinkTitle": "快速链接",
    "moreTab": "更多",
    "addedBy": "添加人%{companyName}",
    "teamsTitle": "团队",
    "helpAndSupport": "应用程序帮助与支持",
    "feedbackTitle": "给出反馈",
    "feedbackDescription": "告诉我们您喜欢这个应用程序的哪些部分以及我们可以在哪里进行改进。",
    "leaveTeamAction": "离开团队",
    "teamActions": "团队行动",
    "leaveTeamLeaveChallenge": "离开此团队意味着离开挑战。您需要加入团队才能继续参与。",
    "familyMembers": "家人",
    "familyMembersDescription": "家人必须年满16岁。他们将对整个平台拥有完整的访问权限，全平台的内容都对他们可见。",
    "learnMoreButton": "了解更多",
    "thvcSelection": {
        "signUpUsingTelus": "用您的Telus Health虚拟护理账户注册",
        "loginGetStarted": "登录虚拟护理以开始",
        "haveAccount": "您是否有虚拟护理账户？",
        "emailHelp": "需要帮忙吗？欢迎联络我们的支持团队",
        "yes": "确认",
        "signMeUp": "不，我要注册"
    },
    "inviteFamilyMember": {
        "label": "邀请家人",
        "btn": "发送邀请",
        "email": "电子邮箱*",
        "firstName": "名字*",
        "lastName": "姓氏*",
        "approval": "我确认我已获准邀请此家人至%{company}",
        "multiSelect1": "此家人在您所在地区是否已经达到成年年龄？",
        "multiSelect2": "此家人是否至少16岁？",
        "confirmTermsPolicy": "我确认我是此人的法定监护人。在我看来，受抚养人已足够成熟，能够同意平台的使用，并且我同意他们加入平台。我将向受抚养人说明，他们在平台上的行为需要是负责任的行为，并将向他们解释平台收集和使用他们资料的方式。",
        "onTheirBehalf": "代表他们。",
        "confirm": "是，我确认上述内容",
        "warning": "家人必须至少年满16岁才能注册",
        "errorMsg": "在尝试继续之前，请查看错误"
    },
    "deleteFamilyMember": {
        "desc": "删除家人的账户属于永久性的操作。",
        "btn": "删除家人",
        "confirmation": {
            "title": "已删除家人",
            "desc": "%{fullName}的账户已删除"
        },
        "areYouSure": "确定要删除%{fullName}的账户吗？"
    },
    "familyInvitationStatus": {
        "active": "活跃的",
        "sent": "已发送邀请"
    },
    "familyInvitationSent": {
        "title": "邀请电邮已发送",
        "desc": "邀请已发送给%{fullName}"
    },
    "programCodeSignup": "在使用%{programCodeLabel} %{programCode}之前，先点击'%{signUpLabel}'",
    "notJoinedCommunityLabel": "加入本社区，查看成员们分享的内容",
    "moda": {
        "installApp": {
            "title": "请注意：Moda Health 会员只能通过其会员仪表板访问 Sprout at Work。",
            "subtitle": "要在您的智能手机上使用 Sprout at Work：",
            "stepOneA": "1. 安装Sprout at Work移动应用程序。",
            "stepOneB": "请勿在移动应用程序上注册或登录。",
            "stepTwo": "2. 用手机登录会员控制面板",
            "stepThree": "3. 浏览 Sprout 健康计划并点击该链接 - 它会打开 Sprout at Work 移动应用程序。"
        }
    },
    "HRISLocationSelection": {
        "title": "您在哪个国家工作？"
    },
    "visibilitySettings": {
        "title": "可见性设置",
        "desc1": "您公司中的其他 Wellbeing 应用成员可以看到吗？",
        "desc2": "您以后可以随时更改此设置。",
        "moreTextQ1": "其他人能看到什么？",
        "moreTextAnswer1": "公司中的人员可以看到您的姓名、个人资料照片和基本个人资料详细信息（例如部门和地点）。这使得该应用程序更具社交性和乐趣。",
        "moreTextQ2": "我会出现在哪里？",
        "moreTextAnswer2": "您将在排行榜和搜索结果中显示为您加入的挑战、社区和活动的参与者。您可以稍后调整。",
        "moreTextAnswer3": "我们不会分享或显示您的个人健康信息，例如您的身高、体重或您跟踪的活动。",
        "btnAgree": "给我看一下就可以了",
        "btnDisagree": "不要让其他成员看到我"
    },
    "privacyPolicyReadMore": "要了解更多信息，请阅读我们的隐私政策",
    "tellMeMore": "告诉我更多",
    "helpUsImprove": {
        "title": "帮助我们改进",
        "desc1": "我们使用记录匿名使用数据的工具。了解人们查看和点击内容的趋势有助于我们改进应用程序。",
        "desc2": "您可以随时将其关闭。",
        "moreTextQ1": "我们看什么",
        "moreTextAnswer1": "我们对总体趋势和统计数据感兴趣，因此我们不会查看个人层面的数据。",
        "moreTextQ2": "我们不会分享您的数据",
        "moreTextAnswer2": "这些数据仅供构建此应用程序的人员使用，以帮助改进该应用程序。我们不会与其他公司（包括您的雇主）分享。",
        "moreTextQ3": "您的数据是匿名的",
        "moreTextAnswer3": "我们的工具不会记录您的姓名、确切位置或任何个人健康信息。",
        "btnAgree": "匿名跟踪我的使用情况",
        "btnDisagree": "我不同意跟踪"
    },
    "deleteAccountTextAppName": "永久删除您的 %{appName} 帐户及其所有数据",
    "anonymousMember": "匿名会员",
    "activitiesToTrack": {
        "title": "要跟踪的活动"
    },
    "includedInMembership": "包含在您的会员资格中",
    "invalidDate": "失效日期",
    "discardsStreamPost": {
        "discardTitle": "放弃帖子？",
        "discardChangesTitle": "放弃更改？",
        "discardPostText": "您确定要放弃您的帖子吗？",
        "discardPostChangesText": "您确定要放弃更改吗？"
    },
    "trackActivityModalTitle": "跟踪%{日期}",
    "noPosts": "没有帖子可看",
    "goalIcon": "目标图标",
    "resetsOn": "于 %{date} 重置",
    "clickForHelp": "单击此处获取帮助",
    "trackActivityInputLabel": "输入 %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "找到的物品",
    "tagState": {
        "active": "积极的",
        "notActive": "不活跃"
    },
    "bonusCheckmarkLabel": "因完成任务而获得 %{bonusLabel} 奖励积分",
    "searchBar": {
        "searching": "搜索 %{term}",
        "result": "搜索结果"
    },
    "activityProgress": "活动进度 - %{levelName} %{percentFilled}% - %{daysLeft} 天后重置",
    "bookmark": {
        "remove": "从保存的项目中删除",
        "save": "保存该项目"
    },
    "bonusMark": {
        "earn": "赚取 %{数量} %{积分}",
        "earned": "您获得了 %{qty} %{points}"
    },
    "tabToTrackActivity": "点击以跟踪活动",
    "videoElementLabel": "%{title}，时长%{duration}，双击播放视频",
    "updatedPoliciesPopup": {
        "title": "我们已更新条款",
        "details": "我们鼓励您阅读以下更新后的政策：",
        "disclaimer": "点击下面的按钮，即表示您同意并承认更新后的政策。",
        "agree": "我同意"
    },
    "editActivityLog": {
        "canNotEditItem": "您无法编辑此条目",
        "canNotEditItemDescription": "编辑不适用于从设备或应用程序同步的活动。",
        "updatedItem": "活动已更新",
        "updatedItemDescription": "您的更改已保存。"
    },
    "login_with_email": "使用电子邮件登录",
    "healthconnect_not_available": "无法连接到 Health Connect。请确保在 Health Connect 应用中启用权限。",
    "registrationField": {
        "required": {
            "firstName": "请输入您的名字",
            "lastName": "请输入您的姓氏",
            "email": "请输入有效的电子邮件地址",
            "password": "请输入有效的密码"
        }
    },
    "settingsErrorMessage": {
        "firstName": "请输入您的名字",
        "lastName": "请输入您的姓氏"
    },
    "requiredValidValue": "请为您的 %{value} 输入有效值",
    "passwordHidden": "密码已隐藏，点击即可显示密码",
    "passwordShown": "显示密码，点击隐藏密码",
    "libraryHeaderContent": {
        "category": "",
        "points": "赚取 %{point} 积分。"
    },
    "scoreCurrentPeriod": "%{text} 是从 %{startDate} 到 %{endDate}",
    "scoreCurrent": "%{text} 是 %{points} 点",
    "abbotResetPasswordModal": {
        "title": "您是否正在尝试访问去年的帐户？",
        "text": " 如果您报名参加了去年的挑战，则该帐户将不再有效。今年你需要报名。",
        "goToResetPasswordBtn": "我在 %{currentYear} 注册",
        "goToSignupBtn": "我尚未在 %{currentYear} 注册"
    },
    "challengeRegistrationClosed": "报名已结束 - 挑战赛已开始",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit 即将停用",
            "description": "切换到 Health Connect 以继续自动跟踪您的活动.",
            "linkBtn": "切换到 Health Connect"
        },
        "newFeatureModal": {
            "label": "需要采取行动",
            "title": "Google Fit 不再支持活动同步",
            "web": {
                "doNotHaveApp": "还没有我们的应用程序？",
                "getAppText": "在此下载",
                "dateNotIncludedDescription": "请使用您的智能手机切换到 Google's Health Connect.",
                "dateIncludedDescription": "我们将在 %{date} 移除 Google Fit 集成。请使用您的智能手机切换到 Google's Health Connect"
            },
            "mobile": {
                "dateNotIncludedDescription": "切换到 Health Connect 以继续自动跟踪您的活动.",
                "dateIncludedDescription": "我们将在 %{date} 移除 Google Fit 集成。切换到 Health Connect 以继续自动跟踪您的活动.",
                "buttonLabel": "切换到 Health Connect"
            }
        }
    }
};